(function(){
  var guardContext = window.PDM_GUARD_CONTEXT || '';
  var PDM_LABMARK_SRC = window.PDM_CONFIG.lab_mark_src;
  var PDM_FLAVMARK_SRC = window.PDM_CONFIG.flavour_mark_src;
  var PDM_CUSTOMISE_BTN_SRC = window.PDM_CONFIG.customise_stripes_src;
  var PDM_RESET_BTN_SRC     = window.PDM_CONFIG.restore_stripes_src;


    // Persistent protection level across modal opens
  var activeGuardLevel = guardContext || 'elite';

  // Subtitle line per level
  var GUARD_TITLES = {
    elite:  'Elite Sports Mouthguard',
    pro:    'Pro Sports Mouthguard',
    performance:   'Performance Sports Mouthguard',
    junior: 'Junior Sports Mouthguard'
  };

  // FEATURES: single source of truth, used everywhere
  var GUARD_FEATURES = {
    elite: '<ul>' +
             '<li>Custom-fitted to your mouth</li>' +
             '<li>Includes Impression Kit and 3-way shipping</li>' +
             '<li>Suitable for ages 13 to adult</li>' +
             '<li>6mm Flex Protection™ design</li>' +
             '<li>Recommended for high-impact sports</li>' +
           '</ul>',
    pro: '<ul>' +
            '<li>Custom-fitted to your mouth</li>' +
            '<li>Includes Impression Kit and 3-way shipping</li>' +
            '<li>Suitable for ages 13 to adult</li>' +
            '<li>5mm Flex Protection™ design</li>' +
            '<li>Recommended for medium-impact sports</li>' +
         '</ul>',
    performance: '<ul>' +
             '<li>Custom-fitted to your mouth</li>' +
             '<li>Includes Impression Kit and 3-way shipping</li>' +
             '<li>Suitable for ages 13 to adult</li>' +
             '<li>4mm single-layer design</li>' +
             '<li>Recommended for low-impact sports</li>' +
          '</ul>',
    junior: '<ul>' +
               '<li>Custom-fitted to your child\'s mouth</li>' +
               '<li>Includes Impression Kit and 3-way shipping</li>' +
               '<li>Recommended for ages under 13</li>' +
               '<li>3.5mm single-layer design</li>' +
               '<li>Suitable for all junior sports</li>' +
            '</ul>'
  };

  // Single helper that applies the current protection level
  window.PDM = window.PDM || {};

    // =========================
  // Modal slideshow (scaffolding only)
  // =========================
  // Global toggle:
  // false -> current static behaviour (no Flickity, no DOM change)
  // true  -> Flickity slideshow (implemented in later stages)
  if (typeof PDM.enableModalSlideshow === 'undefined') {
    PDM.enableModalSlideshow = true;
  }

  // Autoplay rule:
  // Custom stripes ONLY must start paused (implemented in later stages)
  if (typeof PDM.modalSlideshowStartPausedForCustomStripes === 'undefined') {
    PDM.modalSlideshowStartPausedForCustomStripes = true;
  }


  PDM.updateProtectionUI = function(level) {
    level = level || activeGuardLevel || guardContext || 'elite';
    activeGuardLevel = level;

    // 1) Subtitle line
    var prodEl = document.querySelector('#pdm-design-modal .pdm-modal__product');
    if (prodEl && GUARD_TITLES[level]) {
      prodEl.textContent = GUARD_TITLES[level];
    }

    // 2) Features block
    var fEl = document.querySelector('#pdm-design-modal .pdm-modal__features');
    if (fEl && GUARD_FEATURES[level]) {
      fEl.innerHTML = GUARD_FEATURES[level];
    }
  };


    // =========================
  // Modal slideshow scaffolding (no behaviour change yet)
  // =========================
  // Note: Nothing in this module is called in Stage 1/2.
  // Later patches will wire build/rebuild/destroy into modal open + protection-level changes.
  PDM.modalSlideshow = PDM.modalSlideshow || (function() {
    var api = {};

    // Holds Flickity instance once implemented
    api._flkty = null;

    // Tracks the last known selected index (used later for bounce logic)
    api._selectedIndex = 0;

    api.isEnabled = function() {
      return !!PDM.enableModalSlideshow;
    };

    api.prefersReducedMotion = function() {
      try {
        return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      } catch (e) {
        return false;
      }
    };


        // ---- Autoplay policy helpers (scaffolding only; not wired yet) ----

    // Global autoplay allowed flag (later patches may read from theme config)
    api.isAutoplayAllowed = function() {
      return true;
    };

    // Decide whether autoplay should start paused on initial build.
    // Custom stripes ONLY must start paused when:
    // - modalSlideshowStartPausedForCustomStripes is true
    // - AND design is custom stripes (caller will tell us)
    // - AND user does not prefer reduced motion
    api.shouldStartPaused = function(opts) {
      opts = opts || {};
      var isCustomStripes = !!opts.isCustomStripes;

      if (api.prefersReducedMotion()) return true;
      if (isCustomStripes && api.shouldStartPausedForCustomStripes()) return true;

      return false;
    };


    // Later: custom stripes must start paused when this flag is true
    api.shouldStartPausedForCustomStripes = function() {
      return !!PDM.modalSlideshowStartPausedForCustomStripes;
    };

        // ---- DOM getters (no DOM changes; used in later stages) ----
    api.getModalRoot = function() {
      return document.querySelector('#pdm-design-modal .pdm-modal');
    };

    api.getMainImageEl = function() {
      return document.querySelector('#pdm-design-modal .pdm-modal__img');
    };

    api.getViewToggleEl = function() {
      return document.querySelector('#pdm-design-modal .pdm-modal__toggle');
    };

    api.getOverlayEls = function() {
      var root = api.getModalRoot();
      return root ? root.querySelectorAll('.pdm-overlay') : [];
    };

        // =========================
    // Stripe overlays inside slideshow slides (slide 0/1)
    // =========================
    // Important:
    // - Do NOT use class "pdm-overlay" on these images, because PDM.updateOverlays()
    //   queries and manipulates ".pdm-overlay" globally.
    // - We paint these directly from PDM.__stripesState + __pdmResolveOverlaySrc().
    api._stripeSlideOverlayHooked = false;

    api._getCarouselEl = function() {
      var wrap = document.querySelector('#pdm-design-modal .pdm-modal__img-wrap');
      return wrap ? wrap.querySelector('.pdm-modal__carousel') : null;
    };

    api._getSlideCell = function(i) {
      var carousel = api._getCarouselEl();
      if (!carousel) return null;
      var cells = carousel.querySelectorAll('.pdm-modal__slide');
      return (cells && cells[i]) ? cells[i] : null;
    };

        api._ensureStripeOverlayLayer = function(cell) {
      if (!cell) return null;

      // Attach overlays inside the stage inner so they inherit TOP-view scaling
      var inner = cell.querySelector('.pdm-slide-stage__inner');
      if (!inner) return null;

      var layer = inner.querySelector('.pdm-slide-overlays');
      if (layer) return layer;

      layer = document.createElement('div');
      layer.className = 'pdm-slide-overlays';
      inner.appendChild(layer);
      return layer;
    };


    api._ensureStripeOverlayImgs = function(layer) {
      if (!layer) return null;
      var imgs = layer.querySelectorAll('img.pdm-slide-overlay');
      if (imgs && imgs.length >= 3) return imgs;

      layer.innerHTML = '';

      for (var i = 1; i <= 3; i++) {
        var img = document.createElement('img');
        img.className = 'pdm-slide-overlay pdm-slide-overlay--' + i;
        img.alt = '';
        img.setAttribute('aria-hidden', 'true');
        img.setAttribute('data-part', i === 1 ? 'left' : (i === 2 ? 'middle' : 'right'));
        layer.appendChild(img);
      }

      return layer.querySelectorAll('img.pdm-slide-overlay');
    };

    api._paintStripeOverlayImgs = function(imgs, state, view) {
      if (!imgs || imgs.length < 3) return;
      if (!state) return;

      var A = state.A, B = state.B, C = state.C;
      var style = Number(state.style || 3);

      // Use your existing resolver (already in this file)
      var s1 = __pdmResolveOverlaySrc(A, 1, view);
      var s2 = __pdmResolveOverlaySrc(B, 2, view);
      var s3 = __pdmResolveOverlaySrc(C, 3, view);

      function setImg(img, src, show) {
        if (!img) return;
        if (!src || !show) {
          img.style.display = 'none';
          img.removeAttribute('src');
          return;
        }
        img.style.display = '';
        // Keep stable: no fade logic here (avoids flash / timing issues)
        img.style.opacity = '1';
        img.src = src;
      }

      setImg(imgs[0], s1, !!s1);
      setImg(imgs[1], (style === 3 ? s2 : ''), (style === 3 && !!s2));
      setImg(imgs[2], s3, !!s3);
    };

    api.isStripesOverlayActive = function() {
      var modal = api.getModalRoot();
      if (!modal) return false;

      // Match your existing overlay policy
      return modal.classList.contains('is-stripes-custom') || modal.classList.contains('has-stripe-overlays');
    };

    api.updateStripeSlideOverlays = function() {
      if (!api._flkty) return;
      if (!api.isStripesOverlayActive()) return;

      var state = (window.PDM && PDM.__stripesState) ? PDM.__stripesState : null;
      if (!state) return;

      var cell0 = api._getSlideCell(0);
      var cell1 = api._getSlideCell(1);
      if (!cell0 || !cell1) return;

      var layer0 = api._ensureStripeOverlayLayer(cell0);
      var layer1 = api._ensureStripeOverlayLayer(cell1);
      if (!layer0 || !layer1) return;

      var imgs0 = api._ensureStripeOverlayImgs(layer0);
      var imgs1 = api._ensureStripeOverlayImgs(layer1);
      if (!imgs0 || !imgs1) return;

      // Slide 0/1 represent primary/alternate views
      var primaryIsTop = !!api._primaryIsTop;
      var view0 = primaryIsTop ? 'top' : 'front';
      var view1 = primaryIsTop ? 'front' : 'top';

      api._paintStripeOverlayImgs(imgs0, state, view0);
      api._paintStripeOverlayImgs(imgs1, state, view1);
    };

        api.installStripeOverlayUpdateHook = function() {
      if (api._stripeSlideOverlayHooked) return;
      if (!window.PDM || typeof PDM.updateOverlays !== 'function') return;

      var original = PDM.updateOverlays;
      PDM.updateOverlays = function() {
        var res = original.apply(PDM, arguments);

        try {
          if (PDM.modalSlideshow && PDM.modalSlideshow._flkty) {
            // If user is on gallery slides (3+) and makes a stripes change,
            // bounce them back to FRONT view (slide index 1 for stripes).
            if (
              typeof PDM.modalSlideshow.isStripesOverlayActive === 'function' &&
              PDM.modalSlideshow.isStripesOverlayActive() &&
              typeof PDM.modalSlideshow.getSelectedIndex === 'function'
            ) {
              var idx = PDM.modalSlideshow.getSelectedIndex();
              if (idx >= 2) {
                // For stripes, primary is TOP => front is slide 1.
                // Animate the move (no snap).
                try { PDM.modalSlideshow._flkty.select(1, true, false); } catch (e) {}
                try { PDM.modalSlideshow.setSelectedIndex(1); } catch (e) {}
              }
            }

            // Repaint slide 0/1 stripe overlays after any update
            if (typeof PDM.modalSlideshow.updateStripeSlideOverlays === 'function') {
              PDM.modalSlideshow.updateStripeSlideOverlays();
            }
          }
        } catch (e) {}

        return res;
      };

      api._stripeSlideOverlayHooked = true;
    };



        // Gallery mode: hide all view-specific overlays/badges/buttons on slides 3+ (index >= 2)
        // Gallery mode: hide view-specific overlays/badges/buttons on slides 3+ (index >= 2)
    // IMPORTANT:
    // - Do NOT force-show elements on restore; restore previous inline display or remove the override.
    // - Scope queries to the actual modal root (Fancybox clone-safe).
    // - Stripes config (#pdm-stripes-config) should remain visible for CUSTOM stripes,
    //   but can be hidden for PRESET stripes on gallery slides.
        // Gallery mode: toggle a class only.
    // IMPORTANT: Do not change inline display styles here, because other PDM logic
    // controls whether badges/marks/buttons exist/are visible for a given design.
    api.setGalleryMode = function(isGallery) {
      var modal = api.getModalRoot();
      if (!modal) return;

      modal.classList.toggle('pdm-modal--gallery', !!isGallery);
    };





        // ---- Slide data resolution (scaffolding only; not used yet) ----
    // Default extras (slides 3+). Later patches may populate this from theme config / product config.
    api._defaultExtras = [];

    // Protection-level specific extras override defaults when present.
    // Example shape (for later stages):
    // { elite: [ ... ], pro: [ ... ], junior: [ ... ] }
    api._extrasByProtectionLevel = {};

    // Design-category specific extras (e.g. glitter) override level/default when present.
    // Map shape: { glitter: [ ... ], marble: [ ... ] }
    api._extrasByCategory = {};

    // Sub-category specific extras override category/level/default when present.
    // Map shape: { "footy": [ ... ], "rugby": [ ... ] }
    api._extrasBySubcategory = {};

    // Slug specific extras override category/level/default when present.
    // Map shape: { "baby-blue": [ ... ], "pink-glitter": [ ... ] }
    api._extrasBySlug = {};


    // Allows later patches (or theme config) to set defaults safely without overwriting if already set.
    api.setDefaultExtras = function(arr) {
      if (Array.isArray(arr)) api._defaultExtras = arr.slice();
    };

    api.setExtrasByProtectionLevel = function(map) {
      if (map && typeof map === 'object') api._extrasByProtectionLevel = map;
    };

    api.setExtrasByCategory = function(map) {
      if (map && typeof map === 'object') api._extrasByCategory = map;
    };

    api.setExtrasBySubcategory = function(map) {
      if (map && typeof map === 'object') api._extrasBySubcategory = map;
    };

    api.setExtrasBySlug = function(map) {
      if (map && typeof map === 'object') api._extrasBySlug = map;
    };


    // Resolve extras list for a given protection level.
    // If there is a non-empty array for that level, it overrides the defaults.
      api.resolveExtras = function(level, category, subcategory, slug) {
      var lvl = (level || '').toString().toLowerCase();
      var cat = (category || '').toString().toLowerCase();
      var sub = (subcategory || '').toString().toLowerCase();
      var s   = (slug || '').toString().toLowerCase();

      // Helper: if map has the key AND it’s an array (even empty), treat as an override
      function getOverride(map, key) {
        if (!map || typeof map !== 'object') return null;
        if (!key) return null;
        if (!Object.prototype.hasOwnProperty.call(map, key)) return null;
        return (Array.isArray(map[key]) && map[key].length) ? map[key] : null;
      }

      // 1) by_slug overrides everything
      var bySlug = getOverride(api._extrasBySlug, s);
      if (bySlug) return bySlug.slice();

      // 2) by_subcategory overrides category/level/default
      var bySub = getOverride(api._extrasBySubcategory, sub);
      if (bySub) return bySub.slice();

      // 3) by_category overrides level/default
      var byCat = getOverride(api._extrasByCategory, cat);
      if (byCat) return byCat.slice();

      // 4) by_level overrides default
      var byLevel = getOverride(api._extrasByProtectionLevel, lvl);
      if (byLevel) return byLevel.slice();

      // 5) default
      return Array.isArray(api._defaultExtras) ? api._defaultExtras.slice() : [];
    };


    // Resolve the full slide list in the required order:
    // 1) primary, 2) alternate, 3+) extras
    //
    // IMPORTANT: We do NOT guess where URLs come from in v3.0.
    // Callers (later patches) will pass in primary/alternate urls explicitly.
    api.resolveSlides = function(opts) {
      opts = opts || {};
      var primaryUrl = opts.primaryUrl || '';
      var alternateUrl = opts.alternateUrl || '';
      var level = opts.protectionLevel || '';
      var category = opts.designCategory || '';
      var subcategory = opts.designSubcategory || '';
      var slug = opts.slug || '';
      var extras = api.resolveExtras(level, category, subcategory, slug);


      var slides = [];

      if (primaryUrl) slides.push({ type: 'primary', url: primaryUrl });
      if (alternateUrl) slides.push({ type: 'alternate', url: alternateUrl });

      if (Array.isArray(extras) && extras.length) {
        extras.forEach(function(extra) {
          // extra can be a string URL or an object (future-proof)
          if (typeof extra === 'string') {
            slides.push({ type: 'gallery', url: extra });
          } else if (extra && typeof extra === 'object' && extra.url) {
            slides.push({ type: (extra.type || 'gallery'), url: extra.url, meta: extra.meta || null });
          }
        });
      }

      return slides;
    };


        // ---- Index tracking + bounce rules (scaffolding only; not used yet) ----

    // Record the currently selected slide index (later: called from Flickity "select" event)
    api.setSelectedIndex = function(idx) {
      var n = parseInt(idx, 10);
      api._selectedIndex = isNaN(n) ? 0 : n;
    };

    api.getSelectedIndex = function() {
      return typeof api._selectedIndex === 'number' ? api._selectedIndex : 0;
    };

    // When protection level changes, slideshow rebuilds.
    // If user was on slide 3+ (index >= 2), bounce back to slide 1 (index 0).
    // Returns the index to select after rebuild.
    api.getPostRebuildIndex = function() {
      return api.getSelectedIndex() >= 2 ? 0 : api.getSelectedIndex();
    };

    // Used later when wiring the protection-level change flow.
    // Callers can use the return value to decide whether to jump to 0.
    api.shouldBounceToPrimaryOnRebuild = function() {
      return api.getSelectedIndex() >= 2;
    };




        // Build the modal slideshow (Flickity) when enabled.
    // Safe: does nothing unless PDM.enableModalSlideshow === true.
    api.build = function(opts) {
      opts = opts || {};
      if (!api.isEnabled()) return;

      // Prevent double-build
      if (api._flkty) return;

      var wrap = document.querySelector('#pdm-design-modal .pdm-modal__img-wrap');
      if (!wrap) return;

            // Mark modal as "slideshow active" so CSS can scope slideshow-only rules safely
      var modalRoot = api.getModalRoot ? api.getModalRoot() : null;
      if (modalRoot) {
        modalRoot.classList.add('pdm-modal--slideshow');
      }


            // Hide the legacy static image when slideshow is enabled (prevents duplicate rendering)
      var legacyImg = api.getMainImageEl();
      if (legacyImg) {
        legacyImg.style.display = 'none';
      }


      var toggle = api.getViewToggleEl();

            // Determine primary/alternate mapping.
      // Default behaviour:
      // - Stripes => TOP is primary
      // - Non-stripes => FRONT is primary
      var state = (toggle && (toggle.dataset.state === 'top' || toggle.dataset.state === 'front'))
        ? toggle.dataset.state
        : 'front';

            // Hard rules for primary view:
      // - Stripes (preset + custom): TOP is primary (slide 0)
      // - Normal designs: FRONT is primary (slide 0)
      // Do not rely on toggle timing/state when building/rebuilding.
      var mc = (opts.mainCategory || '').toString().toLowerCase();
      if (mc === 'stripes') {
        state = 'top';
      } else {
        state = 'front';
      }

      // Store mapping so other methods can interpret slide 0/1 as front/top correctly
      api._primaryIsTop = (state === 'top');

            // Precompute view mapping for slide 0/1 (used for top-view scaling)
      var __pdmSlide0View = api._primaryIsTop ? 'top' : 'front';
      var __pdmSlide1View = api._primaryIsTop ? 'front' : 'top';





            var frontSrc = (toggle && toggle.dataset.front) ? toggle.dataset.front : (opts.imgFront || '');
      var topSrc   = (toggle && toggle.dataset.top)   ? toggle.dataset.top   : (opts.imgTop   || '');

      // If one view URL is missing, fall back to the other so Flickity still has two usable slides.
      // Prevents "Change view" from flipping overlays without the base image changing.
      if (!frontSrc && topSrc) frontSrc = topSrc;
      if (!topSrc && frontSrc) topSrc = frontSrc;

            // Persist last-known inputs so rebuild can be correct without guessing
      api._lastBuildOpts = {
        name: opts.name || '',
        slug: (opts.slug || '').toString().toLowerCase(),
        imgFront: frontSrc,
        imgTop: topSrc,
        mainCategory: (opts.mainCategory || '').toString().toLowerCase(),
        subCategory: (opts.subCategory || '').toString().toLowerCase(),
        isCustomStripes: !!opts.isCustomStripes
      };





      var primaryUrl   = (state === 'top') ? topSrc : frontSrc;
      var alternateUrl = (state === 'top') ? frontSrc : topSrc;

      // Normalised slide list (extras currently empty unless set elsewhere)
      var slides = api.resolveSlides({
        primaryUrl: primaryUrl,
        alternateUrl: alternateUrl,
        protectionLevel: opts.protectionLevel || '',
        designCategory: (opts.mainCategory || ''),
        designSubcategory: (opts.subCategory || ''),
        slug: (opts.slug || '')
      });


      if (!slides || !slides.length) return;

      // Keep any existing overlay imgs in place; build carousel layer beneath them.
      var carousel = document.createElement('div');
      carousel.className = 'pdm-modal__carousel';

            // Gallery hook: mark carousel if it contains any gallery slides (slides 3+)
      var hasGallery = slides.some(function(s) { return (s && s.type === 'gallery'); });
      if (hasGallery) {
        carousel.classList.add('pdm-modal__carousel--has-gallery');
        carousel.setAttribute('data-has-gallery', 'true');
      }


            slides.forEach(function(s, i) {
        var cell = document.createElement('div');
        cell.className = 'pdm-modal__slide';

                // Mark view for the first two slides only (primary/alternate)
        if (i === 0) cell.setAttribute('data-view', __pdmSlide0View);
        if (i === 1) cell.setAttribute('data-view', __pdmSlide1View);


        // Gallery hook: slides 3+ will have type === 'gallery'
        if (s && s.type === 'gallery') {
          cell.classList.add('pdm-modal__slide--gallery');
          cell.setAttribute('data-slide-kind', 'gallery');
          cell.setAttribute('data-gallery-index', String(i - 1)); // 1-based relative to first gallery slide (3rd overall)
        } else {
          cell.setAttribute('data-slide-kind', s && s.type ? s.type : '');
        }

                // Stage wrapper: fills the slide and holds a scaled inner (for top-view scaling)
        var stage = document.createElement('div');
        stage.className = 'pdm-slide-stage';

        var inner = document.createElement('div');
        inner.className = 'pdm-slide-stage__inner';

        var img = document.createElement('img');
        img.src = s.url;
        img.alt = (opts.name ? (opts.name + ' mouthguard') : 'Smileflex design');

        // Mark slide type for later rules (gallery, etc.)
        img.setAttribute('data-slide-type', s.type || '');

        inner.appendChild(img);
        stage.appendChild(inner);
        cell.appendChild(stage);

        carousel.appendChild(cell);

      });


      // Insert carousel as the first child of the wrap, so overlays remain above it
      wrap.insertBefore(carousel, wrap.firstChild);

      // Flickity init (only if present)
      if (!window.Flickity) return;

      var startPaused = api.shouldStartPaused({ isCustomStripes: !!opts.isCustomStripes });

      api._flkty = new Flickity(carousel, {
        cellAlign: 'center',
        contain: true,
        prevNextButtons: true,
        pageDots: true,
        wrapAround: true,
        draggable: true,
        adaptiveHeight: false,
        selectedAttraction: 0.05,
        friction: 0.4,
        initialIndex: 0,
        // Respect reduced motion + custom stripes start paused
        autoPlay: startPaused ? false : 2500,
        pauseAutoPlayOnHover: false
      });

      api.setSelectedIndex(0);

            // Stripe overlays should live inside slide cells so they move with the base image
      if (typeof api.installStripeOverlayUpdateHook === 'function') {
        api.installStripeOverlayUpdateHook();
      }
      if (typeof api.updateStripeSlideOverlays === 'function') {
        api.updateStripeSlideOverlays();
      }


      if (typeof api.setGalleryMode === 'function') {
        api.setGalleryMode(false);
      }


      // On slide change: track index, sync toggle state for slides 1/2,
      // and update overlays using existing pipeline.
            api._flkty.on('select', function() {
        var idx = api._flkty.selectedIndex || 0;
        api.setSelectedIndex(idx);

        // Hide overlays/UI on gallery slides (3+)
        if (typeof api.setGalleryMode === 'function') {
          api.setGalleryMode(idx >= 2);
        }

        // Slides 0/1: sync toggle state and refresh overlays every time
                if (toggle && idx <= 1) {
          var primaryIsTop = !!api._primaryIsTop;
          var newState = primaryIsTop
            ? (idx === 0 ? 'top' : 'front')
            : (idx === 0 ? 'front' : 'top');

          toggle.dataset.state = newState;

          if (window.PDM && typeof PDM.updateOverlays === 'function') {
            PDM.updateOverlays();
          }

          // Keep slide overlay layers in sync with current stripes state
          if (typeof api.updateStripeSlideOverlays === 'function') {
            api.updateStripeSlideOverlays();
          }
        }

      });
    };


        // Destroy the modal slideshow and remove its DOM.
    // Safe to call repeatedly.
    api.destroy = function() {
      if (api._flkty) {
        try { api._flkty.destroy(); } catch (e) {}
        api._flkty = null;
      }

      var wrap = document.querySelector('#pdm-design-modal .pdm-modal__img-wrap');
      if (!wrap) return;

            // Remove slideshow flag class (restores non-slideshow behaviour)
      var modalRoot = api.getModalRoot ? api.getModalRoot() : null;
      if (modalRoot) {
        modalRoot.classList.remove('pdm-modal--slideshow');
      }


            // Restore the legacy static image when slideshow is destroyed
      var legacyImg = api.getMainImageEl();
      var toggle = api.getViewToggleEl();

      if (legacyImg) {
        // Ensure the restored src matches the current toggle state (front/top)
        if (toggle) {
          var state = toggle.dataset.state || 'front';
          var front = toggle.dataset.front || legacyImg.src;
          var top   = toggle.dataset.top   || legacyImg.src;
          legacyImg.src = (state === 'top') ? top : front;
        }
        legacyImg.style.display = '';
      }


      var carousel = wrap.querySelector('.pdm-modal__carousel');
      if (carousel) {
        try { carousel.parentNode.removeChild(carousel); } catch (e) {}
      }

      api.setSelectedIndex(0);
    };


        // Rebuild slideshow when protection level changes.
    // If bounceToPrimary is true, force index 0 after rebuild.
    api.rebuild = function(opts) {
      opts = opts || {};
      if (!api.isEnabled()) return;

      // Preserve current index unless bounce requested or index >= 2 rule applies
      var targetIndex = 0;
      if (opts.bounceToPrimary) {
        targetIndex = 0;
      } else if (typeof api.getPostRebuildIndex === 'function') {
        targetIndex = api.getPostRebuildIndex();
      }

            // Gather latest inputs from current modal state + stored build inputs
      // (no guessing of external structures; prefer DOM, then stored, then opts)
      var toggle = api.getViewToggleEl();
      var last = api._lastBuildOpts || {};

      var name = (typeof last.name === 'string' && last.name) ? last.name : (opts.name || '');

      var imgFront = (toggle && toggle.dataset.front)
        ? toggle.dataset.front
        : (last.imgFront || opts.imgFront || '');

      var imgTop = (toggle && toggle.dataset.top)
        ? toggle.dataset.top
        : (last.imgTop || opts.imgTop || '');

            var isCustomStripes = (typeof last.isCustomStripes === 'boolean')
        ? last.isCustomStripes
        : !!opts.isCustomStripes;

      var mainCategory = (typeof last.mainCategory === 'string') ? last.mainCategory : (opts.mainCategory || '');
      var subCategory  = (typeof last.subCategory === 'string')  ? last.subCategory  : (opts.subCategory  || '');

      var slug = (typeof last.slug === 'string') ? last.slug : (opts.slug || '');


      // Destroy + rebuild fresh
      api.destroy();
      api.build({
        name: name,
        slug: slug,
        imgFront: imgFront,
        imgTop: imgTop,
        mainCategory: mainCategory,
        subCategory: subCategory,
        isCustomStripes: isCustomStripes,
        protectionLevel: opts.protectionLevel || ''
      });




      // Re-select target index if it exists
      if (api._flkty) {
        try {
          var maxIdx = (typeof api._flkty.slides === 'object' && api._flkty.slides.length) ? (api._flkty.slides.length - 1) : 0;
          var safeIdx = Math.max(0, Math.min(targetIndex, maxIdx));
          if (safeIdx !== 0) api._flkty.select(safeIdx, true, true);
          api.setSelectedIndex(safeIdx);
        } catch (e) {}
      }
    };


        // "Change view" behaviour:
    // Always jumps to slide 1 or 2 (index 0 or 1) regardless of current slide.
    // Any manual interaction pauses autoplay (Flickity site behaviour).
    api.selectPrimaryOrAlternate = function(index0or1) {
      if (!api._flkty) return;

      var idx = (index0or1 === 1) ? 1 : 0;

      // Pause autoplay on manual interaction
      try { if (typeof api._flkty.stopPlayer === 'function') api._flkty.stopPlayer(); } catch (e) {}

            // Animate (no snap) when jumping to slide 0/1
      try { api._flkty.select(idx, true, false); } catch (e) {}

      api.setSelectedIndex(idx);

      // Keep toggle state aligned with the selected primary/alternate slide
      var toggle = api.getViewToggleEl();
      if (toggle) {
        var primaryIsTop = !!api._primaryIsTop;
        var newState = primaryIsTop
          ? (idx === 0 ? 'top' : 'front')
          : (idx === 0 ? 'front' : 'top');

        toggle.dataset.state = newState;

        if (window.PDM && typeof PDM.updateOverlays === 'function') {
          PDM.updateOverlays();
        }
      }
    };


    return api;
  })();



    // === keep Flavour Burst™ features note in sync ===
  window.PDM = window.PDM || {};
  PDM.applyFlavourFeaturesNote = function (overrideSlug) {
    var modalRoot = document.querySelector('#pdm-design-modal');
    if (!modalRoot) return;

    // Prefer explicit slug (from openDesignModalFromCell), fallback to wishlist button
    var slug = '';
    if (overrideSlug) {
      slug = String(overrideSlug || '').toLowerCase();
    } else {
      var wBtn = modalRoot.querySelector('.pdm-wishlist-btn');
      slug = wBtn && wBtn.dataset.slug
        ? String(wBtn.dataset.slug).toLowerCase()
        : '';
    }

    if (!slug || !window.PDM || typeof PDM.getDesignBySlug !== 'function') return;

    var d = PDM.getDesignBySlug(slug);
    if (!d || String(d.main_category || '').toLowerCase() !== 'flavour-burst') return;

    var fEl = modalRoot.querySelector('.pdm-modal__features');
    if (!fEl) return;

    var ul = fEl.querySelector('ul');
    if (!ul) {
      ul = document.createElement('ul');
      fEl.appendChild(ul);
    }

    // Avoid duplicates
    if (ul.querySelector('[data-flavour-feature="1"]')) return;

    var li = document.createElement('li');
    li.textContent = 'Flavoured and scented material';
    li.setAttribute('data-flavour-feature', '1');
    ul.insertBefore(li, ul.firstChild);
  };



  // Base images used INSIDE the modal for all Custom Stripes
var PDM_STRIPES_BASE_FRONT = window.PDM_CONFIG.stripes_base_front;
var PDM_STRIPES_BASE_TOP   = window.PDM_CONFIG.stripes_base_top;

PDM.__stripesIsCustomSession = false;


  var productData = {};
  try { productData = JSON.parse(document.getElementById('pdm-product-json').textContent); } catch(e) { productData = {}; }
  var productTitle = productData && productData.title ? productData.title : '';
  var variantsById = {};
  (productData.variants || []).forEach(function(v){ variantsById[String(v.id)] = v; });

    // Guard products JSON (Option 1) – single source of truth for prices
  var guardVariantsById = {};

  try {
    var gpEl = document.getElementById('pdm-guard-products-json');
    if (gpEl) {
      var guardArr = JSON.parse((gpEl.textContent || '').trim() || '[]');
      (guardArr || []).forEach(function(prod){
        if (!prod || !prod.variants) return;
        (prod.variants || []).forEach(function(v){
          if (!v || typeof v.id === 'undefined') return;
          guardVariantsById[String(v.id)] = v;
        });
      });
    }
  } catch (e) {
    guardVariantsById = {};
  }

    // Modal slideshow extras config (optional)
  // Source: <script id="pdm-modal-slideshow-extras-json" type="application/json">...</script>
  try {
    var extrasEl = document.getElementById('pdm-modal-slideshow-extras-json');
    if (extrasEl && window.PDM && PDM.modalSlideshow) {
      var extrasCfg = JSON.parse((extrasEl.textContent || '').trim() || '{}');

      if (extrasCfg && typeof extrasCfg === 'object') {
        if (typeof PDM.modalSlideshow.setDefaultExtras === 'function' && Array.isArray(extrasCfg.default)) {
          PDM.modalSlideshow.setDefaultExtras(extrasCfg.default);
        }
        if (typeof PDM.modalSlideshow.setExtrasByProtectionLevel === 'function' && extrasCfg.by_level && typeof extrasCfg.by_level === 'object') {
          PDM.modalSlideshow.setExtrasByProtectionLevel(extrasCfg.by_level);
        }
        if (typeof PDM.modalSlideshow.setExtrasByCategory === 'function' && extrasCfg.by_category && typeof extrasCfg.by_category === 'object') {
          PDM.modalSlideshow.setExtrasByCategory(extrasCfg.by_category);
        }
        if (typeof PDM.modalSlideshow.setExtrasBySubcategory === 'function' && extrasCfg.by_subcategory && typeof extrasCfg.by_subcategory === 'object') {
          PDM.modalSlideshow.setExtrasBySubcategory(extrasCfg.by_subcategory);
        }
        if (typeof PDM.modalSlideshow.setExtrasBySlug === 'function' && extrasCfg.by_slug && typeof extrasCfg.by_slug === 'object') {
          PDM.modalSlideshow.setExtrasBySlug(extrasCfg.by_slug);
        }
      }
    }
  } catch (e) {}


  // Helper: get variant ID for current design + level using design JSON
  function getVariantIdForLevel(design, level){
    if (!design || !level) return null;
    var key = 'id_' + String(level).toLowerCase(); // id_elite, id_pro, id_performance, id_junior
    return design[key] || null;
  }

  // Stage 2: price + was + save + instalments driven by guardVariantsById
  window.PDM = window.PDM || {};
    PDM.updateProtectionPrice = function(level){
    level = level || activeGuardLevel || guardContext || 'elite';

    var modalRoot = document.querySelector('#pdm-design-modal');
    if (!modalRoot) return;

    var wBtn = modalRoot.querySelector('.pdm-wishlist-btn');
    var slug = wBtn && wBtn.dataset.slug ? String(wBtn.dataset.slug) : '';
    var priceEl   = document.querySelector('#pdm-design-modal .pdm-modal__price');
    var wasEl     = document.querySelector('#pdm-design-modal .pdm-modal__was');
    var saveEl    = document.querySelector('#pdm-design-modal .pdm-modal__save');
    var instWrap  = document.querySelector('#pdm-design-modal .pdm-instalments');
    var instAmtEl = document.querySelector('#pdm-design-modal .pdm-instalments__amount');

    function clearPriceUI(){
      if (priceEl)  priceEl.textContent = '';
      if (wasEl)    wasEl.textContent = '';
      if (saveEl)   saveEl.textContent = '';
      if (instAmtEl) instAmtEl.textContent = '';
      if (instWrap)  instWrap.style.display = 'none';
    }

    if (!slug || !window.PDM || typeof PDM.getDesignBySlug !== 'function') {
      clearPriceUI();
      return;
    }

    var design = PDM.getDesignBySlug(slug);
    if (!design) {
      clearPriceUI();
      return;
    }

    var variantId = getVariantIdForLevel(design, level);
    if (!variantId) {
      clearPriceUI();
      return;
    }

    // Prefer guardVariantsById (from the 4 guard products), fall back to productData variants
    var v = guardVariantsById[String(variantId)] || variantsById[String(variantId)] || null;
    if (!v || typeof v.price === 'undefined') {
      clearPriceUI();
      return;
    }

    // Price
    if (priceEl) {
      priceEl.textContent = formatMoney(v.price);
    }

    // Was + save %
    var hasCompare = v.compare_at_price && v.compare_at_price > v.price;
    if (wasEl) {
      wasEl.textContent = hasCompare ? formatMoney(v.compare_at_price) : '';
    }
    if (saveEl) {
      if (hasCompare) {
        var pct = Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100);
        saveEl.textContent = 'You save ' + pct + '%!';
      } else {
        saveEl.textContent = '';
      }
    }

    // Instalments (Afterpay / PayPal / Klarna)
    if (instWrap && instAmtEl) {
      if (typeof v.price === 'number') {
        var quarter = Math.round(v.price / 4);
        instAmtEl.textContent = formatMoney(quarter);
        instWrap.style.display = '';
      } else {
        instAmtEl.textContent = '';
        instWrap.style.display = 'none';
      }
    }
  };



    PDM.updateVariantSelect = function(level){
    level = level || activeGuardLevel || guardContext || 'elite';

    var modalRoot = document.querySelector('#pdm-design-modal');
    if (!modalRoot) return;

    // Current design slug (from the wishlist button, same as price function)
    var wBtn = modalRoot.querySelector('.pdm-wishlist-btn');
    var slug = wBtn && wBtn.dataset.slug ? String(wBtn.dataset.slug) : '';
    if (!slug || !window.PDM || typeof PDM.getDesignBySlug !== 'function') return;

    var design = PDM.getDesignBySlug(slug);
    if (!design) return;

    // Re-use the same helper used by price logic
    var variantId = getVariantIdForLevel(design, level);

    var sel = modalRoot.querySelector('select[name="id"]');
    if (!sel) return;

    // Ensure there is at least one option
    var opt = sel.options[0];
    if (!opt) {
      opt = document.createElement('option');
      sel.appendChild(opt);
    }

    // Update only the value (keep the label as the design name)
    opt.value = variantId || '';
    sel.value = opt.value;
  };


  // Helper: what's the current protection level, clone-safe
function pdmGetCurrentLevel(modalRoot) {
  // 1) JS state is king – always updated by the change listener,
  //    and not affected by Fancybox clones / duplicate IDs.
  if (typeof activeGuardLevel !== 'undefined' && activeGuardLevel) {
    return String(activeGuardLevel).toLowerCase();
  }

  // 2) Fallback: look for a live select in the given root (or document)
  var root = modalRoot && modalRoot.querySelector ? modalRoot : document;
  var select = root.querySelector('#pdm-protection-select');
  if (select && select.value) {
    return String(select.value).toLowerCase();
  }

  // 3) Final fallback: Liquid default
  if (typeof guardContext !== 'undefined' && guardContext) {
    return String(guardContext).toLowerCase();
  }

  return 'elite';
}


var formatMoney =
  (window.PDM && typeof window.PDM.formatMoney === 'function')
    ? window.PDM.formatMoney
    : function(cents){ return (cents/100).toFixed(2); };


  // Small helper stays local to modal
  function setWishlistButtonState(btn, saved){
    if (!btn) return;
    btn.classList.toggle('is-active', !!saved);
    var icon = btn.querySelector('i');
    if (icon){
      icon.classList.toggle('fa-regular', !saved);
      icon.classList.toggle('fa-solid',  saved);
    }

    // Mirror main wishlist state onto the stripes save button (pink heart) if it exists
    if (btn.classList.contains('pdm-wishlist-btn--main') || btn.classList.contains('pdm-wishlist-btn')) {
      var sBtn = document.querySelector('#pdm-design-modal .js-stripes-save');
      if (sBtn) {
        sBtn.classList.toggle('is-active', !!saved);

        var ii = sBtn.querySelector('i');
        if (ii){
          ii.classList.add('fa-heart'); // ensure glyph class exists
          ii.classList.remove(saved ? 'fa-regular' : 'fa-solid');
          ii.classList.add(saved ? 'fa-solid' : 'fa-regular');
        }

        sBtn.setAttribute('aria-label', saved ? 'Unsave design' : 'Save design');
        sBtn.setAttribute('title', saved ? 'Unsave design' : 'Save design');
      }
    }
  }





  function pdmUpdateModalMetaForStripes(style, baseSlug){
  // baseSlug is whichever custom stripes slug was opened (2 or 3); we derive the sibling
  var wantSlug = (Number(style) === 2) ? 'custom-2-stripes' : 'custom-3-stripes';
  var d = (window.PDM && PDM.getDesignBySlug) ? PDM.getDesignBySlug(wantSlug) : null;
  if (!d) return;

  var titleEl = document.querySelector('#pdm-design-modal .pdm-modal__title');
if (titleEl) titleEl.textContent = d.name || '';

// Only touch the description text span; do not modify labnote or flavnote
var descWrap = document.querySelector('#pdm-design-modal .pdm-modal__desc');
var textEl   = descWrap && descWrap.querySelector('.pdm-desc__text');
if (textEl) {
  if (d.description) { textEl.textContent = d.description; if (descWrap) descWrap.style.display = ''; }
  else { textEl.textContent = ''; if (descWrap) descWrap.style.display = 'none'; }
}


  // Also keep the product-select option label in sync
  var sel = document.querySelector('#pdm-design-modal select[name="id"]');
  if (sel) {
    var opt = sel.querySelector('option');
    if (opt) opt.textContent = d.name || opt.textContent;
  }
}




  /* ===== Overlays: tiny utilities ===== */
var __pdmColoursMap = null;

function __pdmLoadColoursMap(){
  if (__pdmColoursMap) return __pdmColoursMap;
  try {
    var el = document.getElementById('pdm-colours-json');
    var arr = el ? JSON.parse((el.textContent || '').trim()) : [];
    __pdmColoursMap = {};
    (arr || []).forEach(function(c){
      if (!c || !c.slug) return;
      __pdmColoursMap[String(c.slug).toLowerCase()] = c;
    });
  } catch(e){ __pdmColoursMap = {}; }
  return __pdmColoursMap;
}

function __pdmGetColourObj(colour){
  var slug = (colour && typeof colour === 'object' && colour.slug) ? colour.slug : String(colour || '');
  var map = __pdmLoadColoursMap();
  return map[String(slug).toLowerCase()] || null;
}

function __pdmResolveOverlaySrc(colour, idx, view){
  var obj = __pdmGetColourObj(colour);
  if (!obj) return '';
  var key = 'stripe_' + idx + '_' + (view === 'top' ? 'top' : 'front');
  return obj[key] || '';
}

function __pdmEnsureOverlayImgs(){
  var wrap = document.querySelector('#pdm-design-modal .pdm-modal__img-wrap');
  if (!wrap) return null;
  var list = wrap.querySelectorAll('img.pdm-overlay');
  if (list.length >= 3) return list;

  for (var i = 1; i <= 3; i++){
    var el = document.createElement('img');
    el.className = 'pdm-overlay pdm-overlay--' + i;
    el.alt = '';
    el.setAttribute('aria-hidden', 'true');
    el.setAttribute('data-part', i === 1 ? 'left' : (i === 2 ? 'middle' : 'right'));
    // insert before badge/toggle so UI stays on top
    var before = wrap.querySelector('.pdm-modal__badge') || wrap.querySelector('.pdm-modal__toggle') || null;
    wrap.insertBefore(el, before);
  }
  return wrap.querySelectorAll('img.pdm-overlay');
}


// Preload front + top overlay images for the current stripes state
PDM.preloadStripeOverlaysForState = function (state) {
  if (!state || !window.PDM || typeof PDM.preloadImages !== 'function') return;

  var A = state.A, B = state.B, C = state.C;
  var urls = [];

  ['front', 'top'].forEach(function (view) {
    [ [A, 1], [B, 2], [C, 3] ].forEach(function (pair) {
      var col = pair[0];
      var idx = pair[1];
      var src = __pdmResolveOverlaySrc(col, idx, view);
      if (src && urls.indexOf(src) === -1) urls.push(src);
    });
  });

  if (urls.length) {
    PDM.preloadImages(urls); // fire-and-forget
  }
};

// --- Shared image preloader (used by stripes + view toggle + modal open) ---
window.PDM = window.PDM || {};

PDM.preloadImages = (function () {
  var cache = Object.create(null); // avoid re-preloading the same URL

  return function (urls) {
    if (!urls) return;
    if (!Array.isArray(urls)) urls = [urls];

    urls.forEach(function (src) {
      if (!src) return;
      // Normalise key (avoid dupes with querystrings etc if needed)
      var key = String(src);
      if (cache[key]) return;      // already started once
      cache[key] = true;

      var img = new Image();
      img.src = src;
    });
  };
})();

// Preload global UI assets (labmark, flavour mark, customise/reset buttons)
(function () {
  if (!window.PDM || typeof PDM.preloadImages !== 'function') return;

  var urls = [];

  if (typeof PDM_LABMARK_SRC !== 'undefined' && PDM_LABMARK_SRC) {
    urls.push(PDM_LABMARK_SRC);
  }
  if (typeof PDM_FLAVMARK_SRC !== 'undefined' && PDM_FLAVMARK_SRC) {
    urls.push(PDM_FLAVMARK_SRC);
  }
  if (typeof PDM_CUSTOMISE_BTN_SRC !== 'undefined' && PDM_CUSTOMISE_BTN_SRC) {
    urls.push(PDM_CUSTOMISE_BTN_SRC);
  }
  if (typeof PDM_RESET_BTN_SRC !== 'undefined' && PDM_RESET_BTN_SRC) {
    urls.push(PDM_RESET_BTN_SRC);
  }

  if (urls.length) {
    PDM.preloadImages(urls);
  }
})();


/* Public updater: read PDM.__stripesState and paint overlays */
PDM.updateOverlays = function(){
  // --- Only show overlays for Custom Stripes designs ---
  var modal = document.querySelector('#pdm-design-modal .pdm-modal');
  if (!modal) return;
  // Allow overlays in either editor mode OR preset-overlay mode
var canShowOverlays =
  modal.classList.contains('is-stripes-custom') ||
  modal.classList.contains('has-stripe-overlays');

var overlays = modal.querySelectorAll('.pdm-overlay');
if (!canShowOverlays) {

  overlays.forEach(function(o){
    o.style.display = 'none';
    o.removeAttribute('src');
  });
  return;
}



  var state = window.PDM && PDM.__stripesState;
if (!state) return;

// make sure both views are warmed for this combo
if (PDM.preloadStripeOverlaysForState) {
  PDM.preloadStripeOverlaysForState(state);
}



  var oList = __pdmEnsureOverlayImgs();
  if (!oList || oList.length < 3) return;

  var viewBtn = document.querySelector('#pdm-design-modal .pdm-modal__toggle');
  var view = (viewBtn && viewBtn.dataset.state) || 'front';

  var A = state.A, B = state.B, C = state.C;
  var style = Number(state.style || 3);

    var s1 = __pdmResolveOverlaySrc(A, 1, view);
  var s2 = __pdmResolveOverlaySrc(B, 2, view);
  var s3 = __pdmResolveOverlaySrc(C, 3, view);

  function applyOverlay(img, src, shouldShow) {
    if (!img) return;

    // Ensure we have an opacity transition (once)
    if (!img.__pdmHasTransition) {
      img.style.transition = img.style.transition || 'opacity 0.25s ease';
      img.__pdmHasTransition = true;
    }

    // No src → hide and clear
    if (!src || !shouldShow) {
      img.style.opacity = 0;
      img.style.display = 'none';
      img.removeAttribute('src');
      img.onload = null;
      return;
    }

    // We *are* going to show it: start hidden, then fade in on load
    img.style.display = '';
    img.style.opacity = 0;

    img.onload = function () {
      // When the new file is ready, fade it in
      img.style.opacity = 1;
    };

    // Important: set src *after* opacity = 0 so old pixels never flash
    img.src = src;
  }

  // Left stripe
  applyOverlay(oList[0], s1, !!s1);

  // Middle stripe (only for 3-stripe)
  applyOverlay(oList[1], (style === 3 ? s2 : ''), (style === 3 && !!s2));

  // Right stripe
  applyOverlay(oList[2], s3, !!s3);

};

// =============================================================
// Async composite thumbnail for My Saved (Custom Stripes)
// (REMOVED: no canvas/dataURL thumbnails to avoid storage overload)
// =============================================================
window.PDM = window.PDM || {};
PDM.buildStripeThumbnail = async function () {
  return null;
};




window.PDM = window.PDM || {};
// Map protection level → canonical product URL path
// 🔁 Adjust the paths if your handles differ.
var PDM_GUARD_URLS = {
  elite:  '/products/elite-sports-mouthguard',
  pro:    '/products/pro-sports-mouthguard',
  performance:   '/products/performance-sports-mouthguard',
  junior: '/products/junior-sports-mouthguard'
};

window.PDM = window.PDM || {};
PDM.getCurrentShareUrl = function () {
  // Work out current protection level:
  // 1) activeGuardLevel (user selection, persists)
  // 2) guardContext from Liquid (page default)
  // 3) fallback 'elite'
  var level = (typeof activeGuardLevel !== 'undefined' && activeGuardLevel)
    ? activeGuardLevel
    : (typeof guardContext !== 'undefined' && guardContext)
      ? guardContext
      : 'elite';

  // Look up canonical product path for that level
  var path =
    (typeof PDM_GUARD_URLS !== 'undefined' &&
     PDM_GUARD_URLS &&
     PDM_GUARD_URLS[level])
      ? PDM_GUARD_URLS[level]
      : window.location.pathname; // fallback to whatever page we’re on

  // Base product URL – no query/hash
  var base = window.location.origin + path;

  // Current design slug = whatever the modal is showing right now
  var wBtn = document.querySelector('#pdm-design-modal .pdm-wishlist-btn');
  var slug = (wBtn && wBtn.dataset.slug)
    ? String(wBtn.dataset.slug).toLowerCase()
    : '';

  if (!slug) return base;

  // If this is a custom stripes combo, use the live stripes state
  var st = (window.PDM && PDM.__stripesState) || null;

  if (st && /^custom-(2|3)-stripes$/i.test(slug)) {
    var style  = Number(st.style || 3);
    var toSlug = function (v) {
      return (v && v.slug) ? v.slug : String(v || '');
    };
    var A = toSlug(st.A);
    var B = toSlug(st.B);
    var C = toSlug(st.C);

    // Same shape as before – only base has changed
    return base + '?share=stripes'
      + '&style=' + encodeURIComponent(style)
      + '&a=' + encodeURIComponent(A)
      + '&b=' + encodeURIComponent(B)
      + '&c=' + encodeURIComponent(C);
  }

  // Normal design: slug is enough
  return base + '?share=' + encodeURIComponent(slug);
};




// Keep share URL input in sync if it is visible (desktop "copy" box)
function __pdmRefreshShareFieldIfVisible() {
  try {
    var wrap = document.querySelector('.jt-share-url-wrap');
    if (!wrap) return;

    // If it's hidden, no need to touch it
    var cs = window.getComputedStyle(wrap);
    if (!cs || cs.display === 'none' || cs.visibility === 'hidden') return;

    var input = wrap.querySelector('.jt-share-url');
    if (!input) return;

    var url = (window.PDM && typeof PDM.getCurrentShareUrl === 'function')
      ? PDM.getCurrentShareUrl()
      : window.location.href;

    input.value = url;
  } catch (e) {}
}




  // === ADD: keep properties[Colours] in sync LIVE (no extra script blocks) ===
window.PDM = window.PDM || {};
window.PDM.syncColoursProperty = function(){
  var form  = document.querySelector('#pdm-design-modal form');
  if (!form) return;

  // ensure the hidden input exists
  var input = form.querySelector('#pdm-li-colours');
  if (!input){
    input = document.createElement('input');
    input.type  = 'hidden';
    input.id    = 'pdm-li-colours';
    input.name  = 'properties[Colours]';
    form.appendChild(input);
  }

  // read current design + summary
  var wBtn   = document.querySelector('#pdm-design-modal .pdm-wishlist-btn');
  var slug   = (wBtn && wBtn.dataset.slug) || '';
  var summary = (window.PDM && typeof PDM.getStripeSummary === 'function')
    ? PDM.getStripeSummary(slug)
    : '';

  input.value = summary || '';
};

  // ===========================================================
  // Back button handling (Stage 1: main modal only)
  // ===========================================================
  window.PDM = window.PDM || {};
  PDM.__modalHistoryPushed = false;

  // Track how many history states we pushed for this modal stack.
  // Stage 1 uses only 1 (main modal).
  PDM.__layerDepth = 0;

    PDM.closeDesignModalNow = function () {
    // Prefer jQuery Fancybox (this site uses it)
    try {
      if (window.jQuery && jQuery.fancybox && typeof jQuery.fancybox.getInstance === 'function') {
        var inst = jQuery.fancybox.getInstance();
        if (inst && typeof inst.close === 'function') {
          inst.close();
          return;
        }
      }
    } catch (e) {}

    // Fallbacks (safe no-ops if not present)
    try { if (window.jQuery && jQuery.fancybox && typeof jQuery.fancybox.close === 'function') jQuery.fancybox.close(); } catch (e2) {}
    try { if (window.Fancybox && typeof Fancybox.close === 'function') Fancybox.close(); } catch (e3) {}

    // Last resort inline
    try {
      var el = document.getElementById('pdm-design-modal');
      if (el) el.style.display = 'none';
    } catch (e4) {}
  };


  // When we programmatically unwind history, ignore the resulting popstate(s).
  PDM.__ignorePopstate = false;

    // Push a history state for nested layers (colour picker / guide),
  // since these are opened via data-src triggers (not via our JS addSlide code).
    PDM.__pushNestedStateIfNeeded = function () {
    try {
      if (!window.PDM || !PDM.__modalHistoryPushed) return;

      // Source of truth is OUR depth, not Fancybox timing.
      // Only push when we believe we're at main modal depth (1).
      if ((PDM.__layerDepth || 1) > 1) return;

      history.pushState({ pdm_layer: 2 }, '', window.location.href);
      PDM.__layerDepth = 2;
    } catch (e) {}
  };


  if (!window.__pdm_nested_push_bound) {
    window.__pdm_nested_push_bound = true;

    // Capture clicks on the known nested triggers
    document.addEventListener('click', function (e) {
      try {
        if (!window.PDM || !PDM.__modalHistoryPushed) return;

        var t = e.target;
        var i = 0;
        while (t && i < 6) {
          var id = t.id || '';
          var cls = t.className || '';
          var ds = (t.getAttribute && t.getAttribute('data-src')) ? t.getAttribute('data-src') : '';

          var isColourPicker =
            (id === 'pdm-cp-trigger') || (ds === '#pdm-colour-picker');

          var isGuide =
            (cls && String(cls).indexOf('pdm-guide-helper-btn') !== -1) || (ds === '#pdm-guide');

          if (isColourPicker || isGuide) {
            setTimeout(function () {
              try {
                if (window.PDM && typeof PDM.__pushNestedStateIfNeeded === 'function') {
                  PDM.__pushNestedStateIfNeeded();
                }
              } catch (e3) {}
            }, 0);
            break;
          }

          t = t.parentNode;
          i++;
        }
      } catch (e2) {}
    }, true);
  }


  if (!window.__pdm_back_close_bound) {
    window.__pdm_back_close_bound = true;

    window.addEventListener('popstate', function () {
      try {
        window.PDM = window.PDM || {};

        if (PDM.__ignorePopstate) return;

        // Source of truth: jQuery Fancybox (your site uses it)
        var fb = null;
        try {
          if (window.jQuery && jQuery.fancybox && typeof jQuery.fancybox.getInstance === 'function') {
            fb = jQuery.fancybox.getInstance();
          }
        } catch (e0) {}

        // If no Fancybox instance is open, do nothing.
        // (We only want to "claim" Back when a modal is actually open.)
        if (!fb) return;

                // Decide whether Back should close a nested layer or the main modal.
        // IMPORTANT:
        // - Some nested UI opens as an extra *slide* (currIndex > 0) in the SAME instance.
        // - Some nested UI opens as a SEPARATE jQuery.fancybox instance (currIndex === 0).
        // So: use OUR depth as the source of truth, not currIndex.

        var idx = 0;
        try { idx = Number(fb.currIndex || 0); } catch (e1) { idx = 0; }

        // If our own depth says a nested layer is open, close ONLY that layer.
        if ((PDM.__layerDepth || 1) > 1) {
          try {
            // Case A: nested is a slide inside the same instance
            if (idx > 0 && typeof fb.jumpTo === 'function') {
              fb.jumpTo(idx - 1);
            } else if (idx > 0 && typeof fb.prev === 'function') {
              fb.prev();
            } else {
              // Case B: nested is a separate Fancybox instance
              if (typeof fb.close === 'function') {
                fb.close();
              } else if (window.jQuery && jQuery.fancybox && typeof jQuery.fancybox.close === 'function') {
                jQuery.fancybox.close();
              }
            }
          } catch (e2) {}

          // After closing the nested layer, we are back at the main modal depth.
          PDM.__layerDepth = 1;
          PDM.__modalHistoryPushed = true;
          return;
        }

        // Otherwise, we're at main modal depth: close the design modal and reset flags.
        try {
          if (typeof fb.close === 'function') {
            fb.close();
          } else if (window.jQuery && jQuery.fancybox && typeof jQuery.fancybox.close === 'function') {
            jQuery.fancybox.close();
          }
        } catch (e3) {}

        PDM.__modalHistoryPushed = false;
        PDM.__layerDepth = 0;


      } catch (e) {}
    });


  }


  function openDesignModalFromCell(cell){
    var name   = cell.getAttribute('data-name') || '';
    var slug   = cell.getAttribute('data-slug') || '';

        // Modal slideshow: ensure any previous instance is torn down before re-opening
    // (No behaviour change unless PDM.enableModalSlideshow === true)
    try {
      if (window.PDM && PDM.modalSlideshow && typeof PDM.modalSlideshow.destroy === 'function' && PDM.modalSlideshow.isEnabled()) {
        PDM.modalSlideshow.destroy();
      }
    } catch (e) {}


      // Recently Viewed: record card opens
        try {
      var s = String(slug || '').toLowerCase();

      // If this cell represents a saved custom-stripes variant, record ONLY the variant
      var savedId = cell.getAttribute('data-saved-id') || '';
      if (savedId && window.PDM && PDM.recent && PDM.recent.addVariant) {
        PDM.recent.addVariant(savedId);
      } else if (s && window.PDM && PDM.recent && PDM.recent.addSlug) {
        PDM.recent.addSlug(s);
      }
    } catch(e) {}


    var imgF   = cell.getAttribute('data-img-front') || cell.getAttribute('data-img') || '';
    var imgT   = cell.getAttribute('data-img-top') || '';
    var badge  = cell.getAttribute('data-badge') || '';
    var isLab  = (cell.getAttribute('data-creative-lab') || '') === 'true';
    var isFlavour = (cell.getAttribute('data-main-category') || '').toLowerCase() === 'flavour-burst';
    var id     = cell.getAttribute('data-id-active') || '';
    var desc   = cell.getAttribute('data-desc') || '';

    var $img = document.querySelector('#pdm-design-modal .pdm-modal__img');
if ($img) {
  var mainCat = (cell.getAttribute('data-main-category') || '').toLowerCase();
  var subCat  = (cell.getAttribute('data-sub-category')  || '').toLowerCase();

  var isCustomStripes  = (mainCat === 'stripes' && subCat === 'custom');
  var isPresetStripes  = (mainCat === 'stripes' && subCat !== 'custom');
  var isAnyStripes     = isCustomStripes || isPresetStripes;

  var initialSrc;
  if (isAnyStripes) {
  // ✅ All stripes (custom + preset): fixed base, top view
  initialSrc = PDM_STRIPES_BASE_TOP || imgT || imgF || '';
} else {
  // Everything else: front image
  initialSrc = imgF || '';
}


  var initialAlt = name + ' mouthguard – ' + (isAnyStripes ? 'top view' : 'front view');
  $img.src = initialSrc;
  $img.alt = initialAlt;
}




    var $badge = document.querySelector('#pdm-design-modal .pdm-modal__badge');
if ($badge) {
  // --- NEW: Hide badge completely for any custom-stripe design ---
  var isCustomStripes =
    (cell.getAttribute('data-main-category') || '').toLowerCase() === 'stripes' &&
    (cell.getAttribute('data-sub-category') || '').toLowerCase() === 'custom';

  if (isCustomStripes) {
    $badge.removeAttribute('data-badge');
    $badge.style.display = 'none';
  } else {
    var badgeText = String(badge || '').trim().toLowerCase();
    if (badgeText) {
      $badge.textContent = badgeText.toUpperCase();
      $badge.setAttribute('data-badge', badgeText);
      $badge.style.display = '';
    } else {
      $badge.removeAttribute('data-badge');
      $badge.style.display = 'none';
    }
  }
}


    var labLink = document.querySelector('#pdm-design-modal .pdm-modal__labmark-link');
    var labImg  = document.querySelector('#pdm-design-modal .pdm-modal__labmark');
    if (labLink && labImg) {
      if (isLab) { labImg.src = PDM_LABMARK_SRC; labImg.alt = 'Smileflex CreativeLab'; labLink.style.display = ''; }
      else { labLink.style.display = 'none'; labImg.removeAttribute('src'); }
    }

        
    var flavMark = document.querySelector('#pdm-design-modal .pdm-modal__flavmark');
    if (flavMark) {
      if (isFlavour) {
        flavMark.src = PDM_FLAVMARK_SRC;
        flavMark.alt = 'Flavoured mouthguard';
        flavMark.style.display = '';
      } else {
        flavMark.style.display = 'none';
        flavMark.removeAttribute('src');
      }
    }

    var $toggle = document.querySelector('#pdm-design-modal .pdm-modal__toggle');
if ($toggle) {
  var mainCat = (cell.getAttribute('data-main-category') || '').toLowerCase();
  var subCat  = (cell.getAttribute('data-sub-category')  || '').toLowerCase();

  var isCustomStripes  = (mainCat === 'stripes' && subCat === 'custom');
  var isPresetStripes  = (mainCat === 'stripes' && subCat !== 'custom');
  var isAnyStripes     = isCustomStripes || isPresetStripes;

  var frontSrc, topSrc;

  if (isAnyStripes) {
  // ✅ All stripes (custom + preset): fixed bases inside the modal
  frontSrc = PDM_STRIPES_BASE_FRONT || imgF || '';
  topSrc   = PDM_STRIPES_BASE_TOP   || imgT || '';
} else {
  // Everything else: use the design’s own images
  frontSrc = imgF || '';
  topSrc   = imgT || '';
}


  if (topSrc || frontSrc) {
    $toggle.style.display = '';
    $toggle.dataset.front = frontSrc;
    $toggle.dataset.top   = topSrc;

    // 🔁 All stripes (preset + custom) default to TOP view
    // Non-stripes still start on FRONT
    $toggle.dataset.state = isAnyStripes ? 'top' : 'front';
  } else {
    $toggle.style.display = 'none';
    $toggle.removeAttribute('data-front');
    $toggle.removeAttribute('data-top');
    $toggle.removeAttribute('data-state');
  }
}


// =============================================================
// NEW: Preset stripes should render using base + overlays on open
// (no configurator; just seed state and paint overlays)
// =============================================================
if (isStripesPreset && window.PDM) {
  try {
    // 1) Force base images for preset stripes (same as custom)
    var imgEl = document.querySelector('#pdm-design-modal .pdm-modal__img');
    var toggleEl = document.querySelector('#pdm-design-modal .pdm-modal__toggle');

    var baseTop   = PDM_STRIPES_BASE_TOP   || imgT || imgF || '';
    var baseFront = PDM_STRIPES_BASE_FRONT || imgF || imgT || '';

    if (imgEl) imgEl.src = baseTop || baseFront || '';

    if (toggleEl) {
      toggleEl.style.display = '';
      toggleEl.dataset.front = baseFront || '';
      toggleEl.dataset.top   = baseTop || '';
      toggleEl.dataset.state = 'top';
    }

    // 2) Pull the preset defaults from your design JSON
    var dPreset = (window.PDM && typeof PDM.getDesignBySlug === 'function')
      ? PDM.getDesignBySlug(slug)
      : null;

    if (dPreset) {
      var st = Number(dPreset.default_style || 3);
      if (st !== 2 && st !== 3) st = 3;

      var cols = Array.isArray(dPreset.default_colours) ? dPreset.default_colours.slice(0) : [];
      var mid  = dPreset.default_middle || 'white';

      // For style 2: treat cols as [A,C]
      var A0 = cols[0] || 'blue';
      var B0 = mid || 'white';
      var C0 = (st === 2) ? (cols[1] || cols[2] || 'black') : (cols[2] || 'black');

      // For style 3: treat cols as [A,B,C] (insert mid if only 2)
      if (st === 3 && cols.length === 2) cols.splice(1, 0, mid);
      if (st === 3) {
        A0 = cols[0] || 'blue';
        B0 = cols[1] || mid || 'white';
        C0 = cols[2] || 'black';
      }

      // 3) Seed state (strings are fine; your resolver handles them)
      PDM.__stripesState = { slug: slug, style: st, A: A0, B: B0, C: C0 };

      // 4) Warm both views + paint overlays
      if (PDM.preloadStripeOverlaysForState) PDM.preloadStripeOverlaysForState(PDM.__stripesState);
      if (PDM.updateOverlays) PDM.updateOverlays();
      if (PDM.syncColoursProperty) PDM.syncColoursProperty();
    }
  } catch (e) {}
}





 // ==== Stripes (Custom) UI toggle ====
var mainCat = (cell.getAttribute('data-main-category') || '').toLowerCase();
var subCat  = (cell.getAttribute('data-sub-category') || '').toLowerCase();
var slug    = (cell.getAttribute('data-slug')          || '').toLowerCase();

var isStripesCustom =
  mainCat === 'stripes' &&
  subCat === 'custom';

// Stripes PRESET = stripes but NOT custom
var isStripesPreset =
  mainCat === 'stripes' &&
  subCat !== 'custom';

// Customise stripes is allowed for preset stripes EXCEPT the GWS preset
var isCustomiseAllowed =
  isStripesPreset &&
  slug !== 'gws';


var modalRoot = document.querySelector('#pdm-design-modal .pdm-modal');
if (modalRoot) {
  // Editor mode (shrinks image area) = ONLY custom stripes
modalRoot.classList.toggle('is-stripes-custom', !!isStripesCustom);

// Overlay-allowed mode = custom stripes OR preset stripes
// (This is what lets overlays paint without forcing editor sizing.)
modalRoot.classList.toggle('has-stripe-overlays', !!(isStripesCustom || isStripesPreset));

// Optional: if you still want a preset marker class for CSS/hooks
modalRoot.classList.toggle('is-stripes-preset', !!isStripesPreset);


  // "Customise design" button lives inside the modal (image-based)
  var customiseBtn = modalRoot.querySelector('.pdm-modal__customise-btn');
  if (customiseBtn) {
    // Ensure an <img> exists inside the button
    var cbImg = customiseBtn.querySelector('.pdm-modal__customise-img');
    if (!cbImg) {
      cbImg = document.createElement('img');
      cbImg.className = 'pdm-modal__customise-img';
      cbImg.alt = 'Customise design';
      customiseBtn.appendChild(cbImg);
    }

    if (isCustomiseAllowed) {
      // Show + configure for this preset
      customiseBtn.style.display = '';
      customiseBtn.dataset.presetSlug = slug || '';
      customiseBtn.dataset.mode = 'preset';

      if (typeof PDM_CUSTOMISE_BTN_SRC !== 'undefined' && PDM_CUSTOMISE_BTN_SRC) {
        cbImg.src = PDM_CUSTOMISE_BTN_SRC;
      }
      cbImg.alt = 'Customise design';
    } else {
      // Hide for non-stripes, custom stripes, or the GWS preset
      customiseBtn.style.display = 'none';
      customiseBtn.dataset.presetSlug = '';
      customiseBtn.dataset.mode = 'preset';

      // Safe default image even when hidden
      if (typeof PDM_CUSTOMISE_BTN_SRC !== 'undefined' && PDM_CUSTOMISE_BTN_SRC) {
        cbImg.src = PDM_CUSTOMISE_BTN_SRC;
      }
      cbImg.alt = 'Customise design';
    }
  }
}


var cfg = document.getElementById('pdm-stripes-config');

if (cfg) {
  var shouldShow = !!isStripesCustom;

  // Attribute + inline style + ARIA (defensive trio)
  cfg.toggleAttribute('hidden', !shouldShow);
  cfg.style.display = shouldShow ? '' : 'none';
  cfg.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');

  if (shouldShow) {
    // simple default visuals (no behaviour): select “2 stripes” if slug hints it
    var slug = (cell.getAttribute('data-slug') || '').toLowerCase();
    var defaultStyle = (slug.indexOf('3') >= 0) ? '3' : '2';
    cfg.querySelectorAll('.pdm-sc__style').forEach(function(b){
      var isSel = b.getAttribute('data-style') === defaultStyle;
      b.classList.toggle('is-selected', isSel);
      b.setAttribute('aria-pressed', isSel ? 'true' : 'false');
    });
  }
}

// Overlays show for custom + preset stripes
var overlays = document.querySelectorAll('#pdm-design-modal .pdm-overlay');
if (!(isStripesCustom || isStripesPreset)) {
  overlays.forEach(function(o){ o.style.display = 'none'; o.removeAttribute('src'); });
} else {
  overlays.forEach(function(o){ o.style.display = 'block'; });
}

// ✅ NEW: Seed overlays for PRESET stripes (no configurator)
if (isStripesPreset && window.PDM && typeof PDM.getDesignBySlug === 'function') {
  try {
    var d = PDM.getDesignBySlug(slug);
    if (d) {
      var st = Number(d.default_style || 3);
      if (st !== 2 && st !== 3) st = 3;

      var cols = Array.isArray(d.default_colours) ? d.default_colours.slice(0) : [];
      var mid  = d.default_middle || 'white';

      var A0 = cols[0] || 'blue';
      var B0 = mid || 'white';
      var C0 = (st === 2) ? (cols[1] || cols[2] || 'black') : (cols[2] || cols[1] || 'black');

      if (st === 3 && cols.length === 2) cols.splice(1, 0, mid);
      if (st === 3) { A0 = cols[0] || 'blue'; B0 = cols[1] || mid || 'white'; C0 = cols[2] || 'black'; }

      PDM.__stripesState = { slug: slug, style: st, A: A0, B: B0, C: C0 };

      if (PDM.preloadStripeOverlaysForState) PDM.preloadStripeOverlaysForState(PDM.__stripesState);
      if (PDM.updateOverlays) PDM.updateOverlays();
      if (PDM.syncColoursProperty) PDM.syncColoursProperty();
    }
  } catch(e){}
}




// Detection hook event: announce that a stripes-capable design is open
if (isStripesCustom && window.PDM && typeof PDM.emit === 'function'){
  PDM.emit('pdm:stripe-detected', {
    slug: slug,
    defaults: (PDM.getStripeDefaults ? PDM.getStripeDefaults(slug) : null)
  });
}


    var tEl = document.querySelector('#pdm-design-modal .pdm-modal__title');   if (tEl) tEl.textContent = name;
    var pEl = document.querySelector('#pdm-design-modal .pdm-modal__product'); if (pEl) pEl.textContent = productTitle || '';
    var gEl = document.querySelector('.pdm-modal__guide span'); if (gEl) gEl.textContent = productTitle || '';

        // Protection select initial state on modal open
    var protectionSel = document.getElementById('pdm-protection-select');
    if (protectionSel) {
      var initialLevel = activeGuardLevel || guardContext || 'elite';

      // Always reset Junior age state on a *fresh* modal open,
      // so each new design starts with a blank age selection.
      if (window.PDM && typeof PDM.resetJuniorAgeState === 'function') {
        PDM.resetJuniorAgeState();
      }

      protectionSel.value = initialLevel;

      if (window.PDM && typeof PDM.updateProtectionUI === 'function') {
        PDM.updateProtectionUI(initialLevel);
      }
      if (window.PDM && typeof PDM.updateProtectionPrice === 'function') {
        PDM.updateProtectionPrice(initialLevel);
      }
      if (window.PDM && typeof PDM.updateVariantSelect === 'function') {
        PDM.updateVariantSelect(initialLevel);
      }
      if (window.PDM && typeof PDM.updateJuniorAgeUI === 'function') {
        PDM.updateJuniorAgeUI(initialLevel);
      }
    }





    var priceEl = document.querySelector('#pdm-design-modal .pdm-modal__price');
    var v = id ? (variantsById[String(id)] || null) : null;
    if (priceEl) priceEl.textContent = v ? formatMoney(v.price) : '';

    var wasEl = document.querySelector('#pdm-design-modal .pdm-modal__was');
    var saveEl = document.querySelector('#pdm-design-modal .pdm-modal__save');
    if (wasEl) wasEl.textContent = '';
    if (saveEl) saveEl.textContent = '';
    if (v && v.compare_at_price && v.compare_at_price > v.price) {
      if (wasEl) wasEl.textContent = formatMoney(v.compare_at_price);
      if (saveEl) saveEl.textContent = 'You save ' + Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100) + '%!';
    }

    var instWrap   = document.querySelector('#pdm-design-modal .pdm-instalments');
    var instAmount = document.querySelector('#pdm-design-modal .pdm-instalments__amount');
    if (instWrap && instAmount) {
      if (v && typeof v.price === 'number') { instAmount.textContent = formatMoney(Math.round(v.price / 4)); instWrap.style.display = ''; }
      else { instWrap.style.display = 'none'; instAmount.textContent = ''; }
    }

    // Write only to child anchors; never overwrite the container
var descWrap = document.querySelector('#pdm-design-modal .pdm-modal__desc');
if (descWrap) {
  var textEl = descWrap.querySelector('.pdm-desc__text');
  var labEl  = descWrap.querySelector('.pdm-desc__labnote');

  // base description from the cell/json
  if (textEl) {
    if (desc) { textEl.textContent = desc; descWrap.style.display = ''; }
    else { textEl.textContent = ''; descWrap.style.display = 'none'; }
  }

  // CreativeLab note is decided once on open and never touched by style toggles
if (labEl) {
  var isCreative = (cell.getAttribute('data-creative-lab') || '').toLowerCase() === 'true';
  var isExclusive = (cell.getAttribute('data-exclusive') || '').toLowerCase() === 'true';
  if (isCreative) {
    if (isExclusive) {
      labEl.innerHTML = '<br><br>Exclusively designed by <a href="/pages/creativelab" target="_blank" rel="noopener" style="text-decoration: underline; color: #000;">Smileflex CreativeLab™.</a>';
    } else {
      labEl.innerHTML = '<br><br>Designed by <a href="/pages/creativelab" target="_blank" rel="noopener" style="text-decoration: underline; color: #000;">Smileflex CreativeLab™.</a>';
    }
  } else {
    labEl.textContent = '';
  }
}

}

// Flavour note block: set once on open; do not change it on style toggle
var flavEl = document.querySelector('#pdm-design-modal .pdm-modal__flavnote');
if (flavEl) {
  var isFlavour = (cell.getAttribute('data-main-category') || '').toLowerCase() === 'flavour-burst';
  if (isFlavour) {
    // You can swap this line to pull from your JSON if you store a per-design flavour note.
    flavEl.textContent = 'Flavour and scent are designed to fade naturally over time with regular use.';
    flavEl.hidden = false;
  } else {
    flavEl.textContent = '';
    flavEl.hidden = true;
  }
}


        // Apply features for the current protection level on open
    var fEl = document.querySelector('#pdm-design-modal .pdm-modal__features');
    if (fEl && window.PDM && typeof PDM.updateProtectionUI === 'function') {
      PDM.updateProtectionUI(activeGuardLevel || guardContext || 'elite');
    }

    // NEW: re-apply Flavour Burst™ feature note if this is a flavoured design
    if (window.PDM && typeof PDM.applyFlavourFeaturesNote === 'function') {
      PDM.applyFlavourFeaturesNote(slug);
    }




      /* === Junior age-range UI (show/hide based on selected protection level) === */

  function ensureJuniorAgeField() {
    var form = document.querySelector('#pdm-design-modal form');
    if (!form) return null;

    var atc = form.querySelector('#pdm-modal-add-to-cart');
    if (!atc) return null;

    // Build once
    var host = form.querySelector('#pdm-age-field');
    if (!host) {
      host = document.createElement('div');
      host.id = 'pdm-age-field';
      host.className = 'pdm-age';
      host.style.margin = '-5px 0 20px';

      host.innerHTML =
        '<div class="pdm-age__row" style="display:flex;align-items:center;justify-content:space-between;gap:8px;margin-bottom:6px;">' +
          '<div class="pdm-age__label" style="font-size:13px;font-weight:600;letter-spacing:.01em;">' +
            "Child\u2019s age range" +
          '</div>' +
          '<a class="pdm-age__info" data-fancybox="pdm-design-flow" data-src="#pdm-age-info" href="javascript:;" ' +
             'aria-label="Why we ask for age range" title="Why we ask for age range" ' +
             'style="display:inline-flex;align-items:center;justify-content:center;height:24px;width:24px;flex:0 0 24px;border-radius:999px;background:#fff;border:1px solid #e5e5e5;">' +
            '<img src="//smileflex.com.au/cdn/shop/t/4/assets/more-information-icon.png?v=122510987503438346191646640423" ' +
                 'alt="More information" style="height:16px;width:16px;display:block;" />' +
          '</a>' +
        '</div>' +
        '<select id="pdm-age-select" class="pdm-age__select" name="properties[Child age range]">' +
          '<option value="">-- Select --</option>' +
          '<option value="Under 8">Under 8</option>' +
          '<option value="8–10">8–10</option>' +
          '<option value="11–12">11–12</option>' +
        '</select>';

      // Place immediately before the ATC button
      atc.parentNode.insertBefore(host, atc);

      // Ensure inline modal content exists once per page
      if (!document.getElementById('pdm-age-info')) {
        var info = document.createElement('div');
        info.id = 'pdm-age-info';
        info.setAttribute('style',
          'max-width:520px;background:#fff;line-height:1.55;');
        info.innerHTML =
          '<h3 style="margin:0 0 8px;font-size:18px;font-weight:700;">Why we ask for age range</h3>' +
          '<p style="margin:0 0 10px;font-size:14.5px;color:#333;">' +
            'Choosing the right age range helps us include the most suitable impression tray sizes ' +
            'for your child\u2019s comfort and a more accurate impression.' +
          '</p>' +
          '<ul style="margin:0 0 10px 18px;color:#333;font-size:14.5px;">' +
            '<li>Better comfort = better bite position during the impression.</li>' +
            '<li>Correct tray size improves the accuracy of the final fit.</li>' +
          '</ul>' +
          '<p style="margin:0;font-size:14.5px;color:#333;">' +
            'This does not change the mouthguard\u2019s protection level; it only affects the trays ' +
            'included in your impression kit.' +
          '</p>';
        document.body.appendChild(info);
      }
    }

    var sel = host.querySelector('#pdm-age-select');
    if (sel && !sel.__pdmBound) {
      sel.__pdmBound = true;
      sel.addEventListener('change', function () {
        if (window.PDM && typeof PDM.updateJuniorAgeUI === 'function') {
          PDM.updateJuniorAgeUI('junior'); // re-evaluate within junior mode
        }
        // keep Colours property in sync whenever the user makes a valid choice
        if (window.PDM && PDM.syncColoursProperty) PDM.syncColoursProperty();
      });
    }

    return { host: host, select: sel, atc: atc };
  }

  window.PDM = window.PDM || {};
  PDM.updateJuniorAgeUI = function (level) {
  level = level || activeGuardLevel || guardContext || 'elite';

  var bits = ensureJuniorAgeField();
  if (!bits) return;

  var host = bits.host;
  var sel  = bits.select;
  var atc  = bits.atc;

  function markInvalid(el, on) {
    if (!el) return;
    el.style.borderColor = on ? '#ff3b30' : '#e2e2e2';
    el.style.boxShadow   = on ? '0 0 0 2px rgba(255,59,48,.15)' : 'none';
  }

  function setAtcDisabled(on) {
    if (!atc) return;
    atc.classList.toggle('is-disabled', !!on);
    atc.setAttribute('aria-disabled', on ? 'true' : 'false');
    // keep clicks bubbling for the toast
    atc.removeAttribute('disabled');
  }

  if (level === 'junior') {
    // JUNIOR ON → show field, enforce value, gate ATC
    host.style.display = '';
    if (sel) {
      var hasValue = !!sel.value;
      markInvalid(sel, !hasValue);
      setAtcDisabled(!hasValue);
    }
  } else {
    // JUNIOR OFF → hard reset everything related to child age
    host.style.display = 'none';

    if (sel) {
      sel.value = '';           // clear any previous selection
      markInvalid(sel, false);  // remove red border / shadow
    }

    setAtcDisabled(false);      // fully unlock ATC

    // Also strip any lingering line-item property from the form
    if (atc && atc.form) {
      var form = atc.form;
      var prop = form.querySelector('input[name="properties[Child age range]"]');
      if (prop && prop.parentNode) {
        prop.parentNode.removeChild(prop);
      }
    }
  }
};



// Hard reset for Junior age – used on every fresh modal open
window.PDM = window.PDM || {};
PDM.resetJuniorAgeState = function () {
  var bits = ensureJuniorAgeField();
  if (!bits) return;

  var host = bits.host;
  var sel  = bits.select;
  var atc  = bits.atc;

  // Clear the select value + any validation styling
  if (sel) {
    sel.value = '';
    sel.style.borderColor = '#e2e2e2';
    sel.style.boxShadow   = 'none';
  }

  // Make sure ATC is not blocked by stale state
  if (atc) {
    atc.classList.remove('is-disabled');
    atc.setAttribute('aria-disabled', 'false');

    // Also strip any lingering line-item property from the form
    if (atc.form) {
      var form = atc.form;
      var prop = form.querySelector('input[name="properties[Child age range]"]');
      if (prop && prop.parentNode) {
        prop.parentNode.removeChild(prop);
      }
    }
  }

  // We don’t decide visibility here – that’s still driven by updateJuniorAgeUI(level)
  // so the field will only show when level === 'junior'.
};




  window.PDM = window.PDM || {};
  PDM.setGuardContext = function (level, meta) {
    level = (level || '').toLowerCase() || 'elite';
    activeGuardLevel = level;

    // 1) Sync the dropdown in the modal
    var sel = document.querySelector('#pdm-design-modal #pdm-protection-select');
    if (sel) sel.value = level;

    // 2) Re-run all the existing UI helpers
    if (typeof PDM.updateProtectionUI === 'function') {
      PDM.updateProtectionUI(level);
    }
    if (typeof PDM.updateProtectionPrice === 'function') {
      PDM.updateProtectionPrice(level);
    }
    if (typeof PDM.updateVariantSelect === 'function') {
      PDM.updateVariantSelect(level);
    }
    if (typeof PDM.updateJuniorAgeUI === 'function') {
      PDM.updateJuniorAgeUI(level);
    }
    // NEW: keep Flavour Burst™ feature note when level changes
    if (typeof PDM.applyFlavourFeaturesNote === 'function') {
      PDM.applyFlavourFeaturesNote();
    }

    // 3) Keep share URL in sync if your desktop share box is visible
    if (typeof __pdmRefreshShareFieldIfVisible === 'function') {
      __pdmRefreshShareFieldIfVisible();
    }

      // 4) Toast feedback when protection level changes
  if (window.PDM && typeof PDM.toast === 'function') {
    // If the guide passed meta with a name, you *could* personalise it:
    // var msg = (meta && meta.name)
    //   ? meta.name + ' protection selected.'
    //   : 'Protection level updated.';
    var msg = 'Protection level updated';
    PDM.toast(msg);
  }

  };





    var sel = document.querySelector('#pdm-design-modal select[name="id"]');
    if (sel) { sel.innerHTML = ''; var opt = document.createElement('option'); opt.value = id || ''; opt.textContent = name; sel.appendChild(opt); sel.value = id || ''; }

         // --- wishlist: bind slug + initial state onto the button ---
    var wBtn = document.querySelector('#pdm-design-modal .pdm-wishlist-btn');
    if (wBtn){
      wBtn.dataset.slug = slug;
      if (window.PDM && PDM.isSaved) {
        setWishlistButtonState(wBtn, PDM.isSaved(slug));
      }
    }

    // Stage 2: ensure price matches the active guard level on open
    if (window.PDM && typeof PDM.updateProtectionPrice === 'function') {
      PDM.updateProtectionPrice(activeGuardLevel || guardContext || 'elite');
    }

    // Stage 3: ensure variant ID matches the active guard level on open
    if (window.PDM && typeof PDM.updateVariantSelect === 'function') {
      PDM.updateVariantSelect(activeGuardLevel || guardContext || 'elite');
    }

    // write initial Colours value on open
if (window.PDM && PDM.syncColoursProperty) PDM.syncColoursProperty();



        // Hide desktop share box every time the modal opens
    try {
      if (window.jQuery) {
        jQuery('.jt-share-url-wrap').hide();
      } else {
        var sWrap = document.querySelector('.jt-share-url-wrap');
        if (sWrap) sWrap.style.display = 'none';
      }
    } catch(e){}

    if (window.Fancybox) {
      Fancybox.show(
        [{ src: '#pdm-design-modal', type: 'inline' }],
        { id: 'pdm-design-flow', dragToClose: false, touch: false }
      );
            try { if (window.PDM && typeof PDM.__fbStartPoll === 'function') PDM.__fbStartPoll(); } catch (e) {}

    } else if (window.jQuery && jQuery.fancybox) {
      jQuery.fancybox.open(
  [{ src: '#pdm-design-modal', type: 'inline' }],
  {
    touch: false,

    afterShow: function (instance, current) {
      try {
        if (!window.PDM) return;

        // On first show of the design modal, layerDepth should be at least 1
        if (!PDM.__modalHistoryPushed) return;

        // Sync desired depth from Fancybox index (0 = main modal)
        var idx = 0;
        try { idx = Number(instance.currIndex || 0); } catch (e0) { idx = 0; }
        var desiredDepth = idx + 1;

        // Push history entries until our depth matches the Fancybox index
        while ((PDM.__layerDepth || 1) < desiredDepth) {
          history.pushState({ pdm_layer: (PDM.__layerDepth || 1) + 1 }, '', window.location.href);
          PDM.__layerDepth = (PDM.__layerDepth || 1) + 1;
        }
      } catch (e) {}
    },

    afterClose: function () {
      try {
        if (!window.PDM) return;
        if (!PDM.__modalHistoryPushed) return;

        // If the user closed via X/backdrop, unwind our pushed states
        // so there is no "extra Back press" required.
        var steps = Number(PDM.__layerDepth || 1);

        PDM.__ignorePopstate = true;
        try { history.go(-steps); } catch (e1) {}

        // Reset flags
        PDM.__modalHistoryPushed = false;
        PDM.__layerDepth = 0;

        // Re-enable popstate handling after the history settles
        setTimeout(function () {
          try { PDM.__ignorePopstate = false; } catch (e2) {}
        }, 0);
      } catch (e) {}
    }
  }
);

    } else {
      document.getElementById('pdm-design-modal').style.display = 'block';
    }

        // Push a history state so Android/iOS Back closes the modal first
    try {
      if (window.PDM && !PDM.__modalHistoryPushed) {
        history.pushState({ pdm_modal: 1 }, '', window.location.href);
        PDM.__modalHistoryPushed = true;
        PDM.__layerDepth = 1;
      }
    } catch (e) {}


        // Modal slideshow: defer build until the modal DOM is settled (Fancybox clone-safe)
    // (No behaviour change unless PDM.enableModalSlideshow === true)
    try {
      if (window.PDM && PDM.modalSlideshow && typeof PDM.modalSlideshow.build === 'function' && PDM.modalSlideshow.isEnabled()) {
        setTimeout(function () {
          // Re-read category info from the clicked cell (do not rely on inner block scoping)
          var mainCat = (cell.getAttribute('data-main-category') || '').toLowerCase();
          var subCat  = (cell.getAttribute('data-sub-category')  || '').toLowerCase();
          var isCustomStripes = (mainCat === 'stripes' && subCat === 'custom');

            PDM.modalSlideshow.build({
            // Pass only values we already have in this function (no guessing)
            name: name,
            slug: slug,
            imgFront: imgF,
            imgTop: imgT,
            mainCategory: mainCat,
            subCategory: subCat,
            isCustomStripes: isCustomStripes,
            protectionLevel: (typeof activeGuardLevel !== 'undefined' && activeGuardLevel) ? activeGuardLevel : (guardContext || '')
          });

        }, 0);
      }
    } catch (e) {}


        // Ensure Junior age UI is correct after the modal is fully opened
    try {
      var lvlOnOpen = activeGuardLevel || guardContext || 'elite';
      if (window.PDM && typeof PDM.updateJuniorAgeUI === 'function') {
        // Slight delay to let Fancybox / DOM settle
        setTimeout(function () {
          PDM.updateJuniorAgeUI(lvlOnOpen);
        }, 0);
      }
    } catch (e) {}



  }

  // ===== Shared Stripes Palette (2 & 3 use the same memory) =====
var __PDM_LS_PALETTE = 'pdm_stripes_palette_v1';

function __pdmStripeFamilyKey(slug){
  // Treat both custom-2-stripes and custom-3-stripes as the same family
  return 'custom-stripes';
}

function __pdmLoadPalette(familyKey){
  try {
    var map = JSON.parse(localStorage.getItem(__PDM_LS_PALETTE) || '{}');
    return map[familyKey] || null; // {A:'blue', B:'white', C:'black'}
  } catch(e){ return null; }
}

function __pdmSavePalette(familyKey, A, B, C){
  try {
    var map = JSON.parse(localStorage.getItem(__PDM_LS_PALETTE) || '{}');
    map[familyKey] = { A: A.slug || A, B: B.slug || B, C: C.slug || C };
    localStorage.setItem(__PDM_LS_PALETTE, JSON.stringify(map));
  } catch(e){}
}

  /* ===== Stripes: listeners + picker utilities (inside modal IIFE) ===== */
function __pdmGetColours(){
  try {
    var el = document.getElementById('pdm-colours-json');
    return el ? (JSON.parse((el.textContent || '').trim()) || []) : [];
  } catch(e){ return []; }
}
function __pdmTitle(s){ return String(s||'').replace(/[-_]/g,' ').replace(/\b\w/g, m=>m.toUpperCase()); }


function __pdmBuildPickerGrid(colours, onChoose){
  var picker = document.getElementById('pdm-colour-picker');
  if (!picker) return;

  var groupsWrap = picker.querySelector('.pdm-cp__groups');
  if (!groupsWrap) return;

  // Which slot (A/B/C) is being edited? (set by the opener)
  var activeIdx = Number(picker.getAttribute('data-active-index') || 0);

  // Resolve the currently selected colour for that slot so we can show an active ring
  var st = (window.PDM && PDM.__stripesState) || {};
  var current = (activeIdx === 0) ? st.A : (activeIdx === 1 ? st.B : st.C);
  var currentSlug = current && typeof current === 'object' ? current.slug : current;
  currentSlug = String(currentSlug || '').toLowerCase();

  // Group colours by type (default -> basic), and preserve order
  var order   = ['basic','fluoro','metallic'];
  var labels  = { basic:'Basic', fluoro:'Fluoro', metallic:'Metallic' };
  var grouped = { basic:[], fluoro:[], metallic:[] };

  (colours || []).forEach(function(c){
    var t = String(c.type || 'basic').toLowerCase();
    if (!grouped[t]) grouped[t] = [];
    grouped[t].push(c);
  });

  // Rebuild the DOM
  groupsWrap.innerHTML = '';

  order.forEach(function(key){
    var list = grouped[key];
    if (!list || !list.length) return;

    var sec = document.createElement('div');
    sec.className = 'pdm-cp__group';
    sec.setAttribute('data-group', key);

    var heading = document.createElement('div');
    heading.className = 'pdm-cp__heading';
    heading.textContent = labels[key] || (key.charAt(0).toUpperCase() + key.slice(1));
    sec.appendChild(heading);

    // Chip-like row that wraps (like .pdm-chips)
    var row = document.createElement('div');
    row.className = 'pdm-cp__row';

    list.forEach(function(c){
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pdm-cp__swatch';
      btn.setAttribute('data-slug', c.slug);
      btn.setAttribute('aria-label', c.name || __pdmTitle(c.slug));

      // Mark as active if this is the current colour for the slot being edited
      if (String(c.slug).toLowerCase() === currentSlug){
        btn.classList.add('is-active');
      }

      // dot + label (chip look)
      var dot = document.createElement('span');
      dot.className = 'pdm-cp__dot';
      if (c.swatch_img){
        dot.style.backgroundImage = 'url("' + c.swatch_img + '")';
        dot.style.backgroundSize = 'cover';
        dot.style.backgroundPosition = 'center';
      }

      var name = document.createElement('span');
      name.className = 'pdm-cp__name';
      name.textContent = c.name || __pdmTitle(c.slug);

      btn.appendChild(dot);
      btn.appendChild(name);

      btn.addEventListener('click', function(){
        // Update active ring immediately (purely visual)
        row.querySelectorAll('.pdm-cp__swatch.is-active').forEach(function(x){ x.classList.remove('is-active'); });
        btn.classList.add('is-active');

        // Pass selection back
        if (typeof onChoose === 'function') onChoose(c);

        // Close the picker (your existing Fancybox logic)
        if (window.Fancybox) {
          const fb = Fancybox.getInstance();
          if (fb) {
            const current = fb.getSlide();
            const idx = current ? current.index : -1;
            if (idx > 0) {
              fb.removeSlide(idx);
              fb.jumpTo(idx - 1, { friction: 0 });
            } else {
              fb.back();
            }
          } else {
            Fancybox.close();
          }
        } else if (window.jQuery && jQuery.fancybox) {
          jQuery.fancybox.close();
        }
      });

      row.appendChild(btn);
    });

    sec.appendChild(row);
    groupsWrap.appendChild(sec);
  });
}



function __pdmPaintMiniChips(cfgEl, coloursByIdx){
  var chips = [
    cfgEl.querySelector('.pdm-sc__swatches .pdm-sc__swatch:nth-child(1) .pdm-sc__chip'),
    cfgEl.querySelector('.pdm-sc__swatches .pdm-sc__swatch:nth-child(2) .pdm-sc__chip'),
    cfgEl.querySelector('.pdm-sc__swatches .pdm-sc__swatch:nth-child(3) .pdm-sc__chip')
  ];
  chips.forEach(function(chip, i){
    if (!chip) return;
    var c = coloursByIdx[i];
    if (c && c.swatch_img){
      chip.style.backgroundImage = 'url("'+c.swatch_img+'")';
      chip.style.backgroundSize  = 'cover';
      chip.style.backgroundColor = '';
    } else if (c && c.hex){
      chip.style.backgroundImage = '';
      chip.style.backgroundColor = c.hex;
    }
  });
}
function __pdmUpdateLabel(cfgEl, coloursByIdx, style){
  var names = [
    (coloursByIdx[0] && (coloursByIdx[0].name || __pdmTitle(coloursByIdx[0].slug))) || '',
    (coloursByIdx[1] && (coloursByIdx[1].name || __pdmTitle(coloursByIdx[1].slug))) || '',
    (coloursByIdx[2] && (coloursByIdx[2].name || __pdmTitle(coloursByIdx[2].slug))) || ''
  ];
  var text = (style === 2) ? (names[0] + ' / ' + names[2]) : (names[0] + ' / ' + names[1] + ' / ' + names[2]);
  var lab = cfgEl.querySelector('.pdm-sc__label');
  if (lab) lab.textContent = text.trim().replace(/\s+\/\s+$/, '');
}
function __pdmUpdateSwatchTooltips(cfgEl, coloursByIdx, style){
  try {
    var btns = [
      cfgEl.querySelector('.pdm-sc__swatches .pdm-sc__swatch:nth-child(1)'),
      cfgEl.querySelector('.pdm-sc__swatches .pdm-sc__swatch:nth-child(2)'),
      cfgEl.querySelector('.pdm-sc__swatches .pdm-sc__swatch:nth-child(3)')
    ];

    var names = [
      (coloursByIdx[0] && (coloursByIdx[0].name || __pdmTitle(coloursByIdx[0].slug))) || '',
      (coloursByIdx[1] && (coloursByIdx[1].name || __pdmTitle(coloursByIdx[1].slug))) || '',
      (coloursByIdx[2] && (coloursByIdx[2].name || __pdmTitle(coloursByIdx[2].slug))) || ''
    ];

    btns.forEach(function(b, i){
      if (!b) return;
      // Hide B tooltip for 2-stripe, but still keep it sane if it’s in DOM
      if (i === 1 && Number(style) === 2) {
        b.title = '';
        b.setAttribute('aria-label', 'Stripe B (hidden in 2-stripe)');
        return;
      }
      var label = (names[i] || '');
      b.title = label;
      b.setAttribute('aria-label', label);
    });
  } catch(e){}
}
function __pdmApplyStyleVisibility(cfgEl, style){
  var swatchB = cfgEl.querySelector('.pdm-sc__swatches .pdm-sc__swatch:nth-child(2)');
  if (!swatchB) return;
  swatchB.style.display = (style === 2) ? 'none' : '';
}

// Preload swatch tiles + overlay assets for stripes
function __pdmPreloadStripeAssets(colours){
  if (!window.PDM || typeof PDM.preloadImages !== 'function') return;

  var urls = [];

  // 1) Swatch chip images
  (colours || []).forEach(function (c) {
    if (!c) return;
    if (c.swatch_img) urls.push(c.swatch_img);
  });

  // 2) Overlay PNGs for every colour / position / view
  ['front', 'top'].forEach(function (view) {
    [1, 2, 3].forEach(function (pos) {
      (colours || []).forEach(function (c) {
        if (!c) return;
        // Uses your existing resolver
        var src = __pdmResolveOverlaySrc(c, pos, view);
        if (src) urls.push(src);
      });
    });
  });

  // 3) De-dupe
  var seen = {};
  urls = urls.filter(function (src) {
    if (seen[src]) return false;
    seen[src] = true;
    return true;
  });

  if (!urls.length) return;
  PDM.preloadImages(urls);
}


window.PDM = window.PDM || {};

/**
 * Global crossfade helper for the PDM modal media (base img + stripe overlays).
 * Any PDM code (stripes, front/top toggle, etc.) can call this.
 */
PDM.crossfadeMedia = function (doDuringBlackout) {
  try {
    var modal = document.querySelector('#pdm-design-modal .pdm-modal');
    if (!modal) {
      if (typeof doDuringBlackout === 'function') doDuringBlackout();
      return;
    }

    var DURATION = 130; // was 200 – give overlays a bit more time

    modal.classList.add('pdm-fade-media');

    setTimeout(function () {
      if (typeof doDuringBlackout === 'function') {
        doDuringBlackout();
      }
      modal.classList.remove('pdm-fade-media');
    }, DURATION);
  } catch (e) {
    if (typeof doDuringBlackout === 'function') doDuringBlackout();
  }
};



/* One entry point: called right after modal opens and detects stripes */
window.PDM = window.PDM || {};
window.PDM.wireStripesDesigner = function(opts){
  var cfgEl = document.getElementById('pdm-stripes-config');
  if (!cfgEl || cfgEl.hidden) return;
    // --- PATCH: prevent programmatic opens from writing Undo history ---
  PDM.__stripesIsInitialising = true;


    var colours = __pdmGetColours();

  // Filter out preset-only colours (used for team presets but not selectable as custom swatches)
  colours = Array.isArray(colours)
    ? colours.filter(function(c){
        return !(c && c.preset_only);
      })
    : [];

  if (!colours.length) return;


  // Preload swatch chips + overlays for this palette
  __pdmPreloadStripeAssets(colours);

  // Also preload the fixed base images used inside the stripes modal (front + top)
  (function () {
    if (!window.PDM || typeof PDM.preloadImages !== 'function') return;

    var baseUrls = [];
    try {
      if (typeof PDM_STRIPES_BASE_FRONT !== 'undefined' && PDM_STRIPES_BASE_FRONT) {
        baseUrls.push(PDM_STRIPES_BASE_FRONT);
      }
      if (typeof PDM_STRIPES_BASE_TOP !== 'undefined' && PDM_STRIPES_BASE_TOP && PDM_STRIPES_BASE_TOP !== PDM_STRIPES_BASE_FRONT) {
        baseUrls.push(PDM_STRIPES_BASE_TOP);
      }
    } catch (e) {}

    if (baseUrls.length) {
      PDM.preloadImages(baseUrls);
    }
  })();

  var bySlug = {}; colours.forEach(function(c){ bySlug[(c.slug||'').toLowerCase()] = c; });


// --- BEGIN REPLACEMENT: honour forced initial state from My Saved ---
var slug = String(opts.slug || '').toLowerCase();

// Detect if caller provided a forced initial combo
var hasForced = !!(opts && opts.initial && (opts.initial.A || opts.initial.B || opts.initial.C));

// Ensure palette scope is available to swatch handlers
var familyKey = __pdmStripeFamilyKey(slug);

// Style: forced first, else default
var style = Number(hasForced ? (opts.initial.style || 3) : (opts.defaultStyle || 3));

// Build A/B/C using either forced values or the previous palette/defaults
var A, B, C;

if (hasForced) {
  // Use exactly what we were given; do not infer C from B for 2-stripe
  var aSlug = String(opts.initial.A || 'blue').toLowerCase();
  var bSlug = String(opts.initial.B || 'white').toLowerCase();
  var cSlug = String(opts.initial.C || 'black').toLowerCase();

  A = bySlug[aSlug] || colours[0];
  B = bySlug[bSlug] || bySlug.white || colours[1];
  C = bySlug[cSlug] || colours[2];
} else {
  // Original behaviour (shared palette for the "custom-stripes" family)
  var familyKey = __pdmStripeFamilyKey(slug);
  var saved = __pdmLoadPalette(familyKey);

  var defA = (opts.defaultColours && opts.defaultColours[0]) || 'blue';
  var defB = opts.defaultMiddle || (opts.defaultColours && opts.defaultColours[1]) || 'white';
  var defC = (opts.defaultColours && (opts.defaultColours[2] || opts.defaultColours[1])) || 'black';

  A = bySlug[(saved && saved.A) || defA] || colours[0];
  B = bySlug[(saved && saved.B) || defB] || bySlug.white || colours[1];
  C = bySlug[(saved && saved.C) || defC] || colours[2];
}

// --- NEW: record the previously-open stripes state as an undo step (preserve history across modal close/open) ---
(function commitPreviousOpenToHistory(){
  try {
    // ❌ Do NOT record history when opening presets
    if (!PDM.__stripesIsCustomSession) return;

    // ✅ Do NOT record history for the first open when entering Customise stripes
    if (PDM.__stripesSkipNextOpenHistory) {
      PDM.__stripesSkipNextOpenHistory = false;
      return;
    }

    if (!window.PDM) return;


    // Ensure global history exists
    PDM.__stripesHistory = PDM.__stripesHistory || { undo: [], redo: [], MAX: 50 };
    var h = PDM.__stripesHistory;

    // If we had a previous stripes state, and the new open is different, push the previous into undo
    var prev = PDM.__stripesState;
    if (!prev) return;

    var prevSnap = {
      style: Number(prev.style || 3),
      A: toSlug(prev.A),
      B: toSlug(prev.B),
      C: toSlug(prev.C)
    };

    var nextSnap = snapshotState(); // uses current style/A/B/C we just computed for this open

    // === NEW: normalise comparisons (2-stripe ignores B) ===
function snapKey(s){
  var st = Number(s.style || 3);
  var a  = String(s.A || '');
  var b  = String(s.B || '');
  var c  = String(s.C || '');
  return (st === 2) ? ('2|' + a + '|' + c) : ('3|' + a + '|' + b + '|' + c);
}

var prevKey = snapKey(prevSnap);
var nextKey = snapKey(nextSnap);

if (prevKey === nextKey) return;

// Avoid duplicating if it's already the last undo entry (normalised)
var last = h.undo.length ? h.undo[h.undo.length - 1] : null;
var sameAsLast = last && (snapKey(last) === prevKey);


    if (!sameAsLast) {
      h.undo.push(prevSnap);
      if (h.undo.length > (h.MAX || 50)) h.undo.shift();
    }

    // New open = new timeline → redo should be cleared
    h.redo.length = 0;

    updateUndoRedoUI();
  } catch(e) {
    // fail-safe: never break opening
  }
})();

// Publish state FIRST so all UI + overlays read the correct combo
window.PDM.__stripesState = { slug: slug, style: style, A: A, B: B, C: C };



// Preload both front + top overlays for this combo
if (window.PDM && PDM.preloadStripeOverlaysForState) {
  PDM.preloadStripeOverlaysForState(window.PDM.__stripesState);
}


window.PDM = window.PDM || {};
PDM.__stripesHistory = PDM.__stripesHistory || { undo: [], redo: [], MAX: 50 };


// Toggle later if you change your mind:
var RANDOMISE_CAN_CHANGE_STYLE = true;

function toSlug(v){ return (v && v.slug) ? v.slug : String(v || ''); }

function snapshotState(){
  return {
    style: Number(style || 3),
    A: toSlug(A),
    B: toSlug(B),
    C: toSlug(C)
  };
}

function updateUndoRedoUI(){
  var undoBtn = document.querySelector('.js-stripes-undo');
  var redoBtn = document.querySelector('.js-stripes-redo');
  var h = (window.PDM && PDM.__stripesHistory) ? PDM.__stripesHistory : { undo: [], redo: [] };
if (undoBtn) undoBtn.disabled = !h.undo.length;
if (redoBtn) redoBtn.disabled = !h.redo.length;
}

function pushUndo(){
  var h = (window.PDM && PDM.__stripesHistory) ? PDM.__stripesHistory : null;
  if (!h) return; // fail safe: never break swatch clicking
    // --- PATCH: do not record undo history while stripes are being initialised/opened ---
  if (window.PDM && PDM.__stripesIsInitialising) return;


  h.undo.push(snapshotState());
  if (h.undo.length > (h.MAX || 50)) h.undo.shift();
  h.redo.length = 0;
  updateUndoRedoUI();
}


// Single “apply” path so undo/redo/randomise behave identically
function applyState(st){
  style = Number(st.style || 3);

  A = bySlug[String(st.A || '').toLowerCase()] || A;
  B = bySlug[String(st.B || '').toLowerCase()] || B;
  C = bySlug[String(st.C || '').toLowerCase()] || C;

  // Sync canonical state object
  if (window.PDM && PDM.__stripesState){
    PDM.__stripesState.style = style;
    PDM.__stripesState.A = A;
    PDM.__stripesState.B = B;
    PDM.__stripesState.C = C;
  } else if (window.PDM) {
    PDM.__stripesState = { slug: slug, style: style, A: A, B: B, C: C };
  }

  // Update style buttons
  cfgEl.querySelectorAll('.pdm-sc__style').forEach(function(x){
    var sel = Number(x.getAttribute('data-style') || 3) === style;
    x.classList.toggle('is-selected', sel);
    x.setAttribute('aria-pressed', sel ? 'true' : 'false');
  });

  // UI paint
    __pdmApplyStyleVisibility(cfgEl, style);
  __pdmPaintMiniChips(cfgEl, [A,B,C]);
  __pdmUpdateLabel(cfgEl, [A,B,C], style);
  __pdmUpdateSwatchTooltips(cfgEl, [A,B,C], style);


  // Persist palette
  __pdmSavePalette(familyKey, A, B, C);

  // Preload + overlays + line item property
  if (window.PDM && PDM.preloadStripeOverlaysForState) {
    PDM.preloadStripeOverlaysForState(PDM.__stripesState);
  }
  if (window.PDM && PDM.updateOverlays) PDM.updateOverlays();
  if (window.PDM && PDM.syncColoursProperty) PDM.syncColoursProperty();

  // Swap modal title/desc + wishlist slug for 2/3 base
  try {
    var wBtn = document.querySelector('#pdm-design-modal .pdm-wishlist-btn');

    // Prefer the state slug (most authoritative), then fall back to the button dataset
    var oldSlug =
      (window.PDM && PDM.__stripesState && PDM.__stripesState.slug) ? String(PDM.__stripesState.slug).toLowerCase()
      : (wBtn && wBtn.dataset.slug) ? String(wBtn.dataset.slug).toLowerCase()
      : '';

    var newSlug = (style === 2) ? 'custom-2-stripes' : 'custom-3-stripes';

    // Recently Viewed: record ONLY when the 2↔3 slug actually changes
    // (but do not require oldSlug to be truthy — we just skip if there was no prior slug)
    if (newSlug && oldSlug && newSlug !== oldSlug) {
      try { if (window.PDM && PDM.recent && PDM.recent.addSlug) PDM.recent.addSlug(newSlug); } catch(e) {}
    }


    if (wBtn) wBtn.dataset.slug = newSlug;
    if (window.PDM && PDM.__stripesState) PDM.__stripesState.slug = newSlug;

    if (typeof pdmUpdateModalMetaForStripes === 'function') {
      pdmUpdateModalMetaForStripes(style, newSlug);
    }

    if (typeof __pdmRefreshShareFieldIfVisible === 'function') {
      __pdmRefreshShareFieldIfVisible();
    }

    // Heart sync (uses your existing helper)
    if (window.PDM && typeof PDM.findStripeVariant === 'function') {
      var res = PDM.findStripeVariant(style, toSlug(A), toSlug(B), toSlug(C)) || { exists:false };
      if (wBtn && typeof setWishlistButtonState === 'function') {
        setWishlistButtonState(wBtn, !!res.exists);
        wBtn.setAttribute('aria-pressed', res.exists ? 'true' : 'false');
      }
      if (window.PDM && PDM.setCardHeartState && wBtn) PDM.setCardHeartState(wBtn, !!res.exists);
    }
  } catch(e){}

  updateUndoRedoUI();
}



// Paint UI once from the canonical state
cfgEl.querySelectorAll('.pdm-sc__style').forEach(function(b){
  var isSel = String(b.getAttribute('data-style')) === String(style);
  b.classList.toggle('is-selected', isSel);
  b.setAttribute('aria-pressed', isSel ? 'true' : 'false');
});
__pdmApplyStyleVisibility(cfgEl, style);
__pdmPaintMiniChips(cfgEl, [A, B, C]);
__pdmUpdateLabel(cfgEl, [A, B, C], style);
__pdmUpdateSwatchTooltips(cfgEl, [A, B, C], style);


// Keep overlays + line item in sync with this state immediately
if (window.PDM && PDM.updateOverlays) PDM.updateOverlays();
if (window.PDM && PDM.syncColoursProperty) PDM.syncColoursProperty();
// --- END REPLACEMENT ---

// Init undo/redo buttons on first paint
updateUndoRedoUI();
  // --- PATCH: programmatic init complete (user actions can now create Undo) ---
  PDM.__stripesIsInitialising = false;



  // STYLE toggles
  cfgEl.querySelectorAll('.pdm-sc__style').forEach(function(b){
    b.addEventListener('click', function(){
      var newStyle = Number(b.getAttribute('data-style') || 3);
      if (style === newStyle) return;
      pushUndo();
      style = newStyle;

      cfgEl.querySelectorAll('.pdm-sc__style').forEach(function(x){
        var sel = Number(x.getAttribute('data-style')||0) === style;
        x.classList.toggle('is-selected', sel);
        x.setAttribute('aria-pressed', sel ? 'true' : 'false');
      });
            __pdmApplyStyleVisibility(cfgEl, style);
      __pdmUpdateLabel(cfgEl, [A,B,C], style);
      __pdmUpdateSwatchTooltips(cfgEl, [A,B,C], style);
      if (window.PDM && PDM.__stripesState) PDM.__stripesState.style = style;


      if (window.PDM && PDM.__stripesState) {
  PDM.__stripesState.style = style;
  if (PDM.preloadStripeOverlaysForState) {
    PDM.preloadStripeOverlaysForState(PDM.__stripesState);
  }
}


      // Heart state: reflect whether a matching variant is already saved
(function syncHeart(){
  var wBtn = document.querySelector('#pdm-design-modal .pdm-wishlist-btn');
  if (!wBtn) return;
  var st = (window.PDM && PDM.__stripesState) || {};
  var toSlug = v => (v && v.slug) ? v.slug : String(v||'');
  var res = (PDM.findStripeVariant) ? PDM.findStripeVariant(
              Number(st.style||style), toSlug(st.A), toSlug(st.B), toSlug(st.C)
            ) : { exists:false };
  if (typeof setWishlistButtonState === 'function') setWishlistButtonState(wBtn, !!res.exists);
  if (window.PDM && PDM.setCardHeartState) PDM.setCardHeartState(wBtn, !!res.exists);
  wBtn.setAttribute('aria-pressed', res.exists ? 'true' : 'false');
})();

              // update line item property now that style changed
      if (window.PDM && PDM.syncColoursProperty) PDM.syncColoursProperty();

        if (window.PDM && PDM.updateOverlays) {
    PDM.updateOverlays();
  }




   // === NEW: update modal title/desc to the other base JSON entry
    pdmUpdateModalMetaForStripes(style, (PDM.__stripesState && PDM.__stripesState.slug) || '');
    // After pdmUpdateModalMetaForStripes(...)
    var wBtn = document.querySelector('#pdm-design-modal .pdm-wishlist-btn');

    // capture old slug BEFORE we overwrite it
    var oldSlug =
      (window.PDM && PDM.__stripesState && PDM.__stripesState.slug) ? String(PDM.__stripesState.slug).toLowerCase()
      : (wBtn && wBtn.dataset.slug) ? String(wBtn.dataset.slug).toLowerCase()
      : '';

    var newSlug = (style === 2) ? 'custom-2-stripes' : 'custom-3-stripes';

    if (wBtn) wBtn.dataset.slug = newSlug;
    if (window.PDM && PDM.__stripesState) PDM.__stripesState.slug = newSlug;

    // Recently Viewed: style toggle changes are real "view" events
    if (newSlug && oldSlug && newSlug !== oldSlug) {
      try { if (window.PDM && PDM.recent && PDM.recent.addSlug) PDM.recent.addSlug(newSlug); } catch(e) {}
    }


      // If desktop share box is open, keep the URL in sync with new style
      if (typeof __pdmRefreshShareFieldIfVisible === 'function') {
        __pdmRefreshShareFieldIfVisible();
      }


// Ensure only the description text is swapped for the new style
(function syncDescForStyle(){
  try {
    var descWrap = document.querySelector('#pdm-design-modal .pdm-modal__desc');
    var textEl   = descWrap && descWrap.querySelector('.pdm-desc__text');
    if (!textEl) return;

    var s = Number(style) === 2 ? 2 : 3;
    var slugForStyle = (s === 2) ? 'custom-2-stripes' : 'custom-3-stripes';
    var d = (window.PDM && PDM.getDesignBySlug) ? PDM.getDesignBySlug(slugForStyle) : null;

    var nextDesc = (d && d.description) ? d.description : '';
    textEl.textContent = nextDesc;
    if (descWrap) descWrap.style.display = nextDesc ? '' : 'none';
  } catch(e){}
})();


    });
  });

  // SWATCH clicks → open Colours picker
  var activeIndex = 0;
  cfgEl.querySelectorAll('.pdm-sc__swatches .pdm-sc__swatch').forEach(function(btn, idx){
    btn.addEventListener('click', function(){
      activeIndex = idx;
      document.getElementById('pdm-colour-picker')?.setAttribute('data-active-index', String(activeIndex));
      __pdmBuildPickerGrid(colours, function(chosen){

  // === NEW: ignore no-op picks (prevents duplicate consecutive undo entries) ===
  try {
    var cur = snapshotState();          // {style,A,B,C} as slugs/strings
    var picked = toSlug(chosen);

    var nextA = cur.A, nextB = cur.B, nextC = cur.C;
    if (activeIndex === 0) nextA = picked;
    if (activeIndex === 1) nextB = picked;
    if (activeIndex === 2) nextC = picked;

    var isSame =
      Number(cur.style) === Number(style || 3) && // style hasn’t changed in this action
      String(nextA) === String(cur.A) &&
      String(nextB) === String(cur.B) &&
      String(nextC) === String(cur.C);

    if (isSame) return; // don’t push undo, don’t clear redo, don’t repaint
  } catch (e) {}

  pushUndo();

  if (activeIndex === 0) A = chosen;
  if (activeIndex === 1) B = chosen;
  if (activeIndex === 2) C = chosen;


  __pdmPaintMiniChips(cfgEl, [A,B,C]);
__pdmUpdateLabel(cfgEl, [A,B,C], style);
__pdmUpdateSwatchTooltips(cfgEl, [A,B,C], style);
__pdmSavePalette(familyKey, A, B, C);

if (window.PDM && PDM.__stripesState) {
  PDM.__stripesState.A = A;
  PDM.__stripesState.B = B;
  PDM.__stripesState.C = C;

  // 🔁 NEW: preload both views of overlays for this combo
  if (typeof PDM.preloadStripeOverlaysForState === 'function') {
    PDM.preloadStripeOverlaysForState(PDM.__stripesState);
  }
}

// update line item property now that colour changed
if (window.PDM && PDM.syncColoursProperty) PDM.syncColoursProperty();

  if (window.PDM && PDM.updateOverlays) {
    PDM.updateOverlays();
  }





// Heart state on colour change (normalised for 2-stripe)
(function syncHeart(){
  var wBtn = document.querySelector('#pdm-design-modal .pdm-wishlist-btn');
  if (!wBtn) return;
  var toSlug = v => (v && v.slug) ? v.slug : String(v||'');
  var res = (PDM.findStripeVariant) ? PDM.findStripeVariant(
              Number(style), toSlug(A), toSlug(B), toSlug(C)
            ) : { exists:false };
  if (typeof setWishlistButtonState === 'function') setWishlistButtonState(wBtn, !!res.exists);
  if (window.PDM && PDM.setCardHeartState) PDM.setCardHeartState(wBtn, !!res.exists);
  wBtn.setAttribute('aria-pressed', res.exists ? 'true' : 'false');
})();

  // If desktop share box is open, keep the URL in sync with new colours
  if (typeof __pdmRefreshShareFieldIfVisible === 'function') {
    __pdmRefreshShareFieldIfVisible();
  }



});


      if (window.Fancybox) {
  const fb = Fancybox.getInstance(); // should be the design modal ('pdm-design-flow')
  if (fb) {
    const anchor = document.getElementById('pdm-cp-trigger');
    const src = anchor?.getAttribute('data-src') || '#pdm-colour-picker';
    fb.addSlide({ src, type: 'inline' });
    fb.jumpTo(fb.slides.length - 1);
  } else {
    // Fallback: if somehow no instance exists, click the hidden anchor
    document.getElementById('pdm-cp-trigger')?.click();
  }
} else if (window.jQuery && jQuery.fancybox) {
  // Legacy fallback only
  document.getElementById('pdm-cp-trigger')?.click();
}

    });
  });

  // =========================
// Actions: Undo / Redo / Randomise (route to current session)
// =========================
window.PDM = window.PDM || {};

// Expose the *current* session API so the global click handler always uses the latest one
PDM.__stripesSession = {
  undo: function(){
  var h = PDM.__stripesHistory;
  if (!h || !h.undo.length) return;
  h.redo.push(snapshotState());
  applyState(h.undo.pop());
},
redo: function(){
  var h = PDM.__stripesHistory;
  if (!h || !h.redo.length) return;
  h.undo.push(snapshotState());
  applyState(h.redo.pop());
},

  mirror: function(){
    // Undoable mirror: swap left ↔ right (A ↔ C); keep B as-is
    pushUndo();
    var cur = snapshotState(); // {style,A,B,C} in slugs
    applyState({ style: cur.style, A: cur.C, B: cur.B, C: cur.A });
  },

  randomise: function(){

    pushUndo();

    var newStyle = RANDOMISE_CAN_CHANGE_STYLE
      ? (Math.random() < 0.5 ? 2 : 3)
      : Number(style || 3);

    function pick(){ return colours[Math.floor(Math.random() * colours.length)]; }

    var a = pick();
    var b = pick();
    var c = pick();

    if (newStyle === 2) {
      while (c.slug === a.slug) c = pick();                    // A ≠ C
      // B can be anything; it's hidden anyway, but we still store it
    } else {
      while (b.slug === a.slug || b.slug === c.slug) b = pick(); // B ≠ A and B ≠ C
      // A and C may match
    }

    applyState({ style: newStyle, A: a.slug, B: b.slug, C: c.slug });
  },
  refreshButtons: function(){
    updateUndoRedoUI();
  },
  resetHistory: function(){
  var h = (window.PDM && PDM.__stripesHistory) ? PDM.__stripesHistory : null;
  if (!h) return;
  h.undo.length = 0;
  h.redo.length = 0;
  updateUndoRedoUI();
}

};

// Bind the global click handler once (outside of closure problems)
if (!PDM.__stripesActionsBound) {
  PDM.__stripesActionsBound = true;

    document.addEventListener('click', function(e){
    var s = window.PDM && window.PDM.__stripesSession;
    if (!s) return;

    if (e.target.closest('.js-stripes-undo'))      { s.undo(); return; }
    if (e.target.closest('.js-stripes-redo'))      { s.redo(); return; }
    if (e.target.closest('.js-stripes-mirror'))    { s.mirror(); return; }
    if (e.target.closest('.js-stripes-randomise')) { s.randomise(); return; }

    // Save/Unsave in stripes mode: delegate to the existing modal wishlist button (single source of truth)
    if (e.target.closest('.js-stripes-save')) {
      var wBtn = document.querySelector('#pdm-design-modal .pdm-wishlist-btn--main');
      if (!wBtn) wBtn = document.querySelector('#pdm-design-modal .pdm-wishlist-btn'); // fallback
      if (wBtn) wBtn.click();
      return;
    }
  }, true);


}



  // keep state for next steps
  window.PDM.__stripesState = { slug: slug, style: style, A: A, B: B, C: C };
};

// Customise a stripes PRESET → switch into Custom 2/3 Stripes with seeded colours
window.PDM = window.PDM || {};
PDM.customisePresetStripes = function (presetSlug) {
  PDM.__stripesIsCustomSession = true;
PDM.__stripesSkipNextOpenHistory = true;

  // If slideshow autoplay is running (preset stripes), stop it when entering custom stripes.
  // This matches the "start paused for custom stripes" rule.
  try {
    if (
      window.PDM &&
      PDM.enableModalSlideshow === true &&
      PDM.modalSlideshow &&
      PDM.modalSlideshow._flkty &&
      typeof PDM.modalSlideshow._flkty.stopPlayer === 'function' &&
      PDM.modalSlideshowStartPausedForCustomStripes === true
    ) {
      PDM.modalSlideshow._flkty.stopPlayer();
    }
  } catch (e) {}


    // Remember current view (front/top) so we can preserve it
  var toggleBtn = document.querySelector('#pdm-design-modal .pdm-modal__toggle');
  var currentView = (toggleBtn && toggleBtn.dataset.state) ? toggleBtn.dataset.state : 'top';

  if (!presetSlug || !window.PDM || typeof PDM.getDesignBySlug !== 'function') return;

  var preset = PDM.getDesignBySlug(presetSlug);
  if (!preset) return;

  var mainCat = String(preset.main_category || '').toLowerCase();
  var subCat  = String(preset.sub_category  || '').toLowerCase();

  // Only operate on stripes PRESETS (not custom)
  if (mainCat !== 'stripes' || subCat === 'custom') return;

  // Normalise style + default colours from preset JSON
  var style = Number(preset.default_style || 3);
  if (style !== 2 && style !== 3) style = 3;

  var cols = Array.isArray(preset.default_colours)
    ? preset.default_colours.slice(0)
    : [];
  var mid  = preset.default_middle || cols[1] || 'white';

  var defColours, defMiddle;

  if (style === 2) {
    // Presets typically look like ["red","black"] → treat as [A,C], B = middle
    var pA = cols[0] || 'blue';
    var pC = cols[1] || cols[2] || 'black';
    defColours = [pA, mid, pC];  // A / (hidden B) / C
    defMiddle  = mid;
  } else {
    // 3-stripe presets: want [A,B,C]
    if (cols.length === 2) {
      cols.splice(1, 0, mid);   // ["red","black"] → ["red", mid, "black"]
    }
    defColours = [
      cols[0] || 'blue',
      cols[1] || 'white',
      cols[2] || 'black'
    ];
    defMiddle = defColours[1];
  }

  var customSlug = (style === 2) ? 'custom-2-stripes' : 'custom-3-stripes';

  // Ensure the configurator is visible (presets left it hidden)
  var cfgEl = document.getElementById('pdm-stripes-config');
  if (cfgEl) {
    cfgEl.hidden = false;
    cfgEl.style.display = '';
    cfgEl.setAttribute('aria-hidden', 'false');
  }

  // Switch the modal into "stripes custom" mode
  var modalRoot = document.querySelector('#pdm-design-modal .pdm-modal');
  if (modalRoot) {
    modalRoot.classList.add('is-stripes-custom');
  }
  var actions = document.querySelector('.pdm-stripes-actions-card');
  if (actions) {
    actions.hidden = false;
  }


  // Seed the designer from the preset colours
  if (typeof PDM.wireStripesDesigner === 'function') {
    PDM.wireStripesDesigner({
      slug: customSlug,
      defaultStyle: style,
      defaultColours: defColours,
      defaultMiddle: defMiddle,
      initial: {
        style: style,
        A: defColours[0],
        B: defColours[1],
        C: defColours[2]
      }
    });
  }

  // Make sure stripes state + overlays are in sync
  if (window.PDM) {
    if (!PDM.__stripesState) {
      PDM.__stripesState = {
        slug: customSlug,
        style: style,
        A: defColours[0],
        B: defColours[1],
        C: defColours[2]
      };
    } else {
      PDM.__stripesState.slug  = customSlug;
      PDM.__stripesState.style = style;
    }

    if (typeof PDM.updateOverlays === 'function') {
      PDM.updateOverlays();
    }
    if (typeof PDM.syncColoursProperty === 'function') {
      PDM.syncColoursProperty();
    }
  }

    // Update the main modal image + front/top toggle to use stripes base images
  (function () {
    var imgEl  = document.querySelector('#pdm-design-modal .pdm-modal__img');
    var toggle = document.querySelector('#pdm-design-modal .pdm-modal__toggle');

    // Work out what view we were on before customising
    var currentView = (toggle && (toggle.dataset.state === 'front' || toggle.dataset.state === 'top'))
      ? toggle.dataset.state
      : 'top'; // default for stripes if nothing set

    // Resolve base images (fall back to whatever we already have)
    var baseTop = (typeof PDM_STRIPES_BASE_TOP !== 'undefined' && PDM_STRIPES_BASE_TOP)
      ? PDM_STRIPES_BASE_TOP
      : (toggle && toggle.dataset.top) || (imgEl && imgEl.src) || '';

    var baseFront = (typeof PDM_STRIPES_BASE_FRONT !== 'undefined' && PDM_STRIPES_BASE_FRONT)
      ? PDM_STRIPES_BASE_FRONT
      : (toggle && toggle.dataset.front) || (imgEl && imgEl.src) || '';

    // Keep the toggle in sync with that view
    if (toggle) {
      toggle.style.display = '';
      toggle.dataset.front = baseFront || '';
      toggle.dataset.top   = baseTop   || '';
      toggle.dataset.state = currentView;
    }

    // Set the main image based on the same view the user was on
    if (imgEl) {
      var nextSrc = (currentView === 'front')
        ? (baseFront || baseTop)
        : (baseTop   || baseFront);

      if (nextSrc) {
        imgEl.src = nextSrc;

        // Clean/remove any old "... – front view/top view" suffix
        var baseAlt = (imgEl.alt || '')
          .replace(/front view|top view/gi, '')
          .replace(/\s+–\s*$/, '')
          .trim();

        if (!baseAlt) {
          baseAlt = (preset.name || 'Custom stripes') + ' mouthguard';
        }

        imgEl.alt = baseAlt + ' – ' + (currentView === 'front' ? 'front view' : 'top view');
      }
    }
  })();


  // Update title/description to the custom 2/3 stripes JSON text
  if (typeof pdmUpdateModalMetaForStripes === 'function') {
    pdmUpdateModalMetaForStripes(style, customSlug);
  }

  // Point wishlist + share logic at the custom stripes slug
  var wBtn = document.querySelector('#pdm-design-modal .pdm-wishlist-btn');
  if (wBtn) {
    wBtn.dataset.slug = customSlug;
  }

  // Refresh desktop share field if visible
  if (typeof __pdmRefreshShareFieldIfVisible === 'function') {
    __pdmRefreshShareFieldIfVisible();
  }
};

// Revert a customised stripes preset back to its original preset design
PDM.resetPresetStripes = function (presetSlug, viewHint) {
  if (!presetSlug || !window.PDM || typeof PDM.getDesignBySlug !== 'function') return;

  var preset = PDM.getDesignBySlug(presetSlug);
  if (!preset) return;

  var mainCat = String(preset.main_category || '').toLowerCase();
  var subCat  = String(preset.sub_category  || '').toLowerCase();

  // Only operate on stripes PRESETS (not custom)
  if (mainCat !== 'stripes' || subCat === 'custom') return;

  var modalRoot = document.querySelector('#pdm-design-modal .pdm-modal');
  if (!modalRoot) return;

  // 1) Turn OFF stripes-custom mode
  modalRoot.classList.remove('is-stripes-custom');
  modalRoot.classList.add('has-stripe-overlays');

  var actions = document.querySelector('.pdm-stripes-actions-card');
  if (actions) {
    actions.hidden = true;
  }


  // Hide the stripes configurator again
  var cfgEl = document.getElementById('pdm-stripes-config');
  if (cfgEl) {
    cfgEl.hidden = true;
    cfgEl.style.display = 'none';
    cfgEl.setAttribute('aria-hidden', 'true');
  }

  // 2) Restore preset stripes as overlay state (do NOT null it)
if (window.PDM) {
  PDM.__stripesState = {
    slug: presetSlug,
    style: Number(preset.default_style || 3),
    A: preset.default_colours?.[0] || 'blue',
    B: preset.default_middle || preset.default_colours?.[1] || 'white',
    C: preset.default_colours?.[2] || preset.default_colours?.[1] || 'black'
  };

  // Ensure overlays repaint immediately
  if (PDM.preloadStripeOverlaysForState) {
    PDM.preloadStripeOverlaysForState(PDM.__stripesState);
  }
  if (PDM.updateOverlays) {
    PDM.updateOverlays();
  }
}


  // Hide overlay <img>s and clear their src
  var overlays = modalRoot.querySelectorAll('.pdm-overlay');
  overlays.forEach(function (o) {
    o.style.display = 'none';
    o.style.opacity = 0;
    o.removeAttribute('src');
  });

    // 3) Restore main image + front/top toggle using STRIPES BASES (not JSON)
var imgEl  = document.querySelector('#pdm-design-modal .pdm-modal__img');
var toggle = document.querySelector('#pdm-design-modal .pdm-modal__toggle');

var front = PDM_STRIPES_BASE_FRONT || '';
var top   = PDM_STRIPES_BASE_TOP   || '';


  // Decide which view we should show:
  // 1) honour explicit viewHint passed from the button ('front' | 'top')
  // 2) otherwise keep whatever the toggle currently says
  // 3) otherwise default to 'top' for stripes if we have a top image, else 'front'
  var nextView;
  if (viewHint === 'front' || viewHint === 'top') {
    nextView = viewHint;
  } else if (toggle && (toggle.dataset.state === 'front' || toggle.dataset.state === 'top')) {
    nextView = toggle.dataset.state;
  } else {
    nextView = top ? 'top' : 'front';
  }

  // Keep the toggle in sync
  if (toggle) {
    if (top) {
      toggle.style.display = '';
      toggle.dataset.front = front || '';
      toggle.dataset.top   = top   || '';
      toggle.dataset.state = nextView;
    } else {
      toggle.style.display = 'none';
      toggle.removeAttribute('data-front');
      toggle.removeAttribute('data-top');
      toggle.removeAttribute('data-state');
    }
  }

  // Set the main image based on the chosen view
  if (imgEl) {
    var nextSrc = (nextView === 'front')
      ? (front || top)
      : (top   || front);

    if (nextSrc) {
      imgEl.src = nextSrc;

      // Clean up any old "... – front view/top view" suffix and re-apply correctly
      var baseAlt = (imgEl.alt || '')
        .replace(/front view|top view/gi, '')
        .replace(/\s+–\s*$/, '')
        .trim();

      if (!baseAlt) {
        baseAlt = (preset.name || 'Sports mouthguard') + ' mouthguard';
      }

      imgEl.alt = baseAlt + ' – ' + (nextView === 'front' ? 'front view' : 'top view');
    }
  }


  // 4) Restore title + description text (leave labnote/flavnote alone)
  var titleEl = document.querySelector('#pdm-design-modal .pdm-modal__title');
  if (titleEl) {
    titleEl.textContent = preset.name || '';
  }

  var descWrap = document.querySelector('#pdm-design-modal .pdm-modal__desc');
  if (descWrap) {
    var textEl = descWrap.querySelector('.pdm-desc__text');
    if (textEl) {
      var desc = preset.description || '';
      textEl.textContent = desc;
      descWrap.style.display = desc ? '' : 'none';
    }
    // we deliberately DO NOT touch .pdm-desc__labnote
  }

  // 5) Point wishlist + share URL back at the preset slug
  var wBtn = document.querySelector('#pdm-design-modal .pdm-wishlist-btn');
  if (wBtn) {
    wBtn.dataset.slug = presetSlug;

    if (PDM.isSaved) {
      var isSaved = !!PDM.isSaved(presetSlug);
      if (typeof setWishlistButtonState === 'function') {
        setWishlistButtonState(wBtn, isSaved);
      }
      if (PDM.setCardHeartState) {
        PDM.setCardHeartState(wBtn, isSaved);
      }
      wBtn.setAttribute('aria-pressed', isSaved ? 'true' : 'false');
    }
  }

  // 6) Refresh desktop share field if visible
  if (typeof __pdmRefreshShareFieldIfVisible === 'function') {
    __pdmRefreshShareFieldIfVisible();
  }

  // 🔁 FORCE initial stripe paint after restore
setTimeout(function () {
  if (!window.PDM) return;

  var modalRoot = document.querySelector('#pdm-design-modal .pdm-modal');
  if (!modalRoot) return;

  // ✅ Overlays allowed, but NOT editor mode (prevents image shrinking)
  modalRoot.classList.add('has-stripe-overlays');
  modalRoot.classList.remove('is-stripes-custom');

  if (PDM.preloadStripeOverlaysForState && PDM.__stripesState) {
    PDM.preloadStripeOverlaysForState(PDM.__stripesState);
  }

  if (PDM.updateOverlays) {
    PDM.updateOverlays();
  }
}, 0);



  // Optional little toast so you know it fired
  if (window.PDM && typeof PDM.toast === 'function') {
    PDM.toast('Preset design restored');
  }
};



// One-time colour name lookup (slug -> Display Name) using #pdm-colours-json
window.PDM = window.PDM || {};
PDM.getColourName = (function(){
  var cache = null;
  return function(slug){
    try{
      if (!cache){
        var el = document.getElementById('pdm-colours-json');
        var arr = el ? JSON.parse((el.textContent||'').trim()) : [];
        cache = {};
        (arr||[]).forEach(function(c){
          if (!c || !c.slug) return;
          cache[String(c.slug).toLowerCase()] = c.name || c.slug;
        });
      }
      var key = String(slug||'').toLowerCase();
      return cache && cache[key] ? cache[key] : null;
    }catch(e){ return null; }
  };
})();

/* ===========================================================
   PDM.getStripeSummary(slug)
   Ensures display uses proper Colour Names (e.g., "Red / Black"),
   even when defaults are plain slugs like ["red","black"].
   =========================================================== */
window.PDM = window.PDM || {};
PDM.getStripeSummary = function(slug){
  slug = String(slug||'').toLowerCase();
  var d = (PDM.getDesignBySlug ? PDM.getDesignBySlug(slug) : null);
  if (!d || String(d.main_category||'').toLowerCase() !== 'stripes') return '';

  // Helper: pretty name from object or slug
  function pretty(c){
    // Object with a proper .name (live state) wins
    if (c && typeof c === 'object'){
      if (c.name) return c.name;
      if (c.slug){
        var fromMap = PDM.getColourName && PDM.getColourName(c.slug);
        if (fromMap) return fromMap;
        return String(c.slug).replace(/[-_]/g,' ').replace(/\b\w/g, m=>m.toUpperCase());
      }
      return '';
    }
    // String slug from defaults/presets
    var s = String(c||'');
    var fromMap = PDM.getColourName && PDM.getColourName(s);
    if (fromMap) return fromMap;
    return s.replace(/[-_]/g,' ').replace(/\b\w/g, m=>m.toUpperCase());
  }

  // If live custom state exists (user interacted), prefer that
  var st = window.PDM && window.PDM.__stripesState;
  if (st && st.slug === slug){
    var namesLive = [
      pretty(st.A),
      pretty(st.B),
      pretty(st.C)
    ];
    return (Number(st.style) === 2)
      ? [namesLive[0], namesLive[2]].filter(Boolean).join(' / ')
      : namesLive.filter(Boolean).join(' / ');
  }

  // Fallback to design defaults (covers presets)
  var cols  = Array.isArray(d.default_colours) ? d.default_colours.slice(0) : [];
  var mid   = d.default_middle || 'white';
  var style = Number(d.default_style || 3);

  if (style === 2){
    // For 2-stripe presets you usually pass ["red","black"]
    var two = (cols.length === 2) ? cols : [cols[0], cols[2]];
    return two.map(pretty).filter(Boolean).join(' / ');
  } else {
    if (cols.length === 2) cols.splice(1, 0, mid);
    return cols.map(pretty).filter(Boolean).join(' / ');
  }
};



/* ===== Wrap modal open so stripes are initialised when custom design opens ===== */
(function(){
  var __origOpenDesign = openDesignModalFromCell;



  openDesignModalFromCell = function(cell){
    __origOpenDesign(cell); // build the modal first

      // Best-effort preload for this design's front/top images
  (function () {
    if (!cell || !window.PDM || typeof PDM.preloadImages !== 'function') return;

    var front = cell.getAttribute('data-img-front') || cell.getAttribute('data-front') || '';
    var top   = cell.getAttribute('data-img-top')   || cell.getAttribute('data-img')   || '';

    var urls = [];
    if (front) urls.push(front);
    if (top && top !== front) urls.push(top);

    if (urls.length) {
      PDM.preloadImages(urls); // fire-and-forget
    }
  })();


    // If opened from My Saved and slug implies custom stripes, force stripes mode
(function(){
  var modalRoot = document.querySelector('#pdm-design-modal .pdm-modal');
  if (!modalRoot) return;

  var slug = (cell.getAttribute('data-slug') || '').toLowerCase();
  var isSavedVariant = cell.hasAttribute('data-saved-variant');
  var looksLikeCustomStripes = /custom-(2|3)-stripes/.test(slug);

  if (isSavedVariant && looksLikeCustomStripes) {
    // Ensure the class that unhides the configurator
    modalRoot.classList.add('is-stripes-custom');

    // Ensure the view toggle + base image are wired for top view by default
    var imgFront = PDM_STRIPES_BASE_FRONT; // always use fixed bases in modal
var imgTop   = PDM_STRIPES_BASE_TOP;

var $img = document.querySelector('#pdm-design-modal .pdm-modal__img');
var $toggle = document.querySelector('#pdm-design-modal .pdm-modal__toggle');
if ($img) {
  $img.src = imgTop || imgFront || '';
  $img.alt = (($img.alt || '').replace(/front view|top view/i,'') + ' top view').trim();
}
if ($toggle) {
  $toggle.style.display = '';
  $toggle.dataset.front = imgFront || '';
  $toggle.dataset.top   = imgTop   || '';
  $toggle.dataset.state = 'top';
}

  }
  var actions = document.querySelector('.pdm-stripes-actions-card');
if (actions) {
  actions.hidden = false;
}

})();


    // Only for Custom Stripes
    var isStripesCustom =
      (cell.getAttribute('data-main-category') || '').toLowerCase() === 'stripes' &&
      (cell.getAttribute('data-sub-category') || '').toLowerCase() === 'custom';
    if (!isStripesCustom) return;

    var slug = (cell.getAttribute('data-slug') || '').toLowerCase();
    var familyKey = __pdmStripeFamilyKey(slug);

    // --- Prefer the exact saved variant when opening from "My Saved" ---
    var hasSavedVariant = cell.hasAttribute('data-saved-variant');
    var cfg = { style: 3, colours: ['blue','white','black'], middle: 'white' }; // safe fallback

    if (hasSavedVariant) {
  var svStyle = Number(cell.getAttribute('data-saved-style') || 3);
  var svA = (cell.getAttribute('data-saved-a') || 'blue');
  var svB = (cell.getAttribute('data-saved-b') || 'white');
  var svC = (cell.getAttribute('data-saved-c') || 'black');
  cfg = {
    style: svStyle,
    // IMPORTANT: always pass [A,B,C]; the UI hides B when style === 2
    colours: [svA, svB, svC],
    middle: svB
  };
} else {
  // Fallback to shared palette/localStorage (always feed A,B,C)
  var saved = __pdmLoadPalette(familyKey);
  var isTwo = slug.indexOf('2') >= 0;
  cfg = {
    style: isTwo ? 2 : 3,
    colours: [
      (saved && saved.A) || 'blue',
      (saved && saved.B) || 'white',
      (saved && saved.C) || 'black'
    ],
    middle: (saved && saved.B) || 'white'
  };
}


    // Initialise the designer with the chosen state
    if (window.PDM && typeof window.PDM.wireStripesDesigner === 'function'){
      window.PDM.wireStripesDesigner({
  slug: slug,
  defaultStyle: cfg.style,
  defaultColours: cfg.colours,
  defaultMiddle: cfg.middle,
  // Force exactly what was saved to My Saved (no reconstruction)
  initial: hasSavedVariant ? {
    style: svStyle,
    A: svA,
    B: svB, // still stored even if hidden
    C: svC
  } : null
});


      if (window.PDM && PDM.updateOverlays) PDM.updateOverlays();
if (window.PDM && PDM.syncColoursProperty) PDM.syncColoursProperty();
if (typeof pdmUpdateModalMetaForStripes === 'function') {
  pdmUpdateModalMetaForStripes(cfg.style, slug);
}

    }

    // Force the desc text to match the saved style’s sibling JSON (2 vs 3)
(function syncSavedStyleDesc(){
  try {
    var descWrap = document.querySelector('#pdm-design-modal .pdm-modal__desc');
    var textEl   = descWrap && descWrap.querySelector('.pdm-desc__text');
    if (!textEl) return;

    var styleNow = (window.PDM && PDM.__stripesState && Number(PDM.__stripesState.style)) || Number(cfg.style) || 3;
    var targetSlug = (styleNow === 2) ? 'custom-2-stripes' : 'custom-3-stripes';
    var d = (window.PDM && PDM.getDesignBySlug) ? PDM.getDesignBySlug(targetSlug) : null;

    var nextDesc = (d && d.description) ? d.description : '';
    textEl.textContent = nextDesc;
    if (descWrap) descWrap.style.display = nextDesc ? '' : 'none';
  } catch(e){}
})();


    // Solid heart if this exact saved variant exists
    (function ensureHeartState(){
      var wBtn = document.querySelector('#pdm-design-modal .pdm-wishlist-btn');
      if (!wBtn) return;

      var st = (window.PDM && PDM.__stripesState) || {};
var toSlug = function(x){ return (x && x.slug) ? x.slug : String(x || ''); };
var s  = Number(st.style || cfg.style || 3);
var a  = toSlug(st.A || cfg.colours[0]);
var b  = toSlug(st.B || cfg.middle || cfg.colours[1]);
var c  = toSlug(st.C || cfg.colours[(cfg.style===2)?1:2]);

var res = (window.PDM && PDM.findStripeVariant) ? PDM.findStripeVariant(s, a, b, c)
                                                : { exists:false };

var isSaved = !!res.exists;
if (typeof setWishlistButtonState === 'function') setWishlistButtonState(wBtn, isSaved);
if (window.PDM && PDM.setCardHeartState) PDM.setCardHeartState(wBtn, isSaved);
wBtn.setAttribute('aria-pressed', isSaved ? 'true' : 'false');

    })();

    // Ensure line-item property is in sync immediately
    if (window.PDM && PDM.syncColoursProperty) PDM.syncColoursProperty();
  };
})();



  // Open modal from the button only (thumbnail does NOT open modal)
document.addEventListener('click', function(e){
  // Allow open from grid AND from My Saved
  var trigger = e.target.closest('.pdm-designs-btn a, .pdm-saved-card a, [data-open-design]');
  if (!trigger) return;

  // Find the most data-rich wrapper available
  var cell =
    trigger.closest('[data-slug]') ||
    trigger.closest('.pdm-designs-cell') ||
    trigger.closest('.pdm-saved-card');

  if (!cell) return;
  e.preventDefault();

  // If coming from My Saved and this is a saved custom-stripes variant,
  // ensure the attributes your modal init expects actually exist.
  var slug = (cell.getAttribute('data-slug') || '').toLowerCase();
  var isSavedVariant = cell.hasAttribute('data-saved-variant');

  if (isSavedVariant && /custom-(2|3)-stripes/.test(slug)) {
    // Force the identifiers your init logic checks
    if (!cell.hasAttribute('data-main-category')) cell.setAttribute('data-main-category', 'stripes');
    if (!cell.hasAttribute('data-sub-category'))  cell.setAttribute('data-sub-category',  'custom');

    // Make sure we have top/front URLs available for the toggle + overlays
    // Try to lift from dataset fallbacks if the attributes weren’t set
    if (!cell.getAttribute('data-img-top')) {
      var topSrc = cell.getAttribute('data-top') || cell.getAttribute('data-img') || '';
      if (topSrc) cell.setAttribute('data-img-top', topSrc);
    }
    if (!cell.getAttribute('data-img-front')) {
      var frontSrc = cell.getAttribute('data-front') || cell.getAttribute('data-img-front') || '';
      if (!frontSrc) {
        // As a last resort, reuse top for front so the UI still loads
        frontSrc = cell.getAttribute('data-img-top') || '';
      }
      if (frontSrc) cell.setAttribute('data-img-front', frontSrc);
    }
  }

  openDesignModalFromCell(cell);
});

// "Customise design" button inside the modal – toggle preset ↔ custom stripes
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.pdm-modal__customise-btn');
  if (!btn) return;

  e.preventDefault();

  var presetSlug = btn.dataset.presetSlug || '';
  if (!presetSlug) return;

  var mode = btn.dataset.mode || 'preset';

  // Capture the current view (front/top) so we can restore it on reset
  var toggleEl = document.querySelector('#pdm-design-modal .pdm-modal__toggle');
  var currentView = (toggleEl && (toggleEl.dataset.state === 'front' || toggleEl.dataset.state === 'top'))
    ? toggleEl.dataset.state
    : 'top';

  // Customise/reset icon inside the button (if present)
  var img = btn.querySelector('.pdm-modal__customise-img');

  // Helper: sync the modal wishlist heart with a boolean
  function syncModalHeart(isSaved) {
    var wBtn = document.querySelector('#pdm-design-modal .pdm-wishlist-btn');
    if (!wBtn) return;

    if (typeof setWishlistButtonState === 'function') {
      setWishlistButtonState(wBtn, !!isSaved);
    } else {
      // Fallback: basic class/icon toggling
      wBtn.classList.toggle('is-active', !!isSaved);
      var icon = wBtn.querySelector('i.fa-heart');
      if (icon) {
        icon.classList.toggle('fa-regular', !isSaved);
        icon.classList.toggle('fa-solid', !!isSaved);
      }
    }

    if (window.PDM && PDM.setCardHeartState) {
      PDM.setCardHeartState(wBtn, !!isSaved);
    }

    wBtn.setAttribute('aria-pressed', isSaved ? 'true' : 'false');
  }

    if (mode === 'preset') {

    // --- NEW: hide preset badge while in custom stripes; store for restore ---
    (function(){
      var $badge = document.querySelector('#pdm-design-modal .pdm-modal__badge');
      if (!$badge) return;

      // store current badge state on the button (survives while modal stays open)
      btn.dataset.prevBadgeText = $badge.getAttribute('data-badge') || '';
      btn.dataset.prevBadgeDisplay = ($badge.style.display === 'none') ? 'none' : '';

      // hide it for custom session
      $badge.removeAttribute('data-badge');
      $badge.style.display = 'none';
    })();

    // Go into CUSTOM stripes mode, seeded from preset
    if (window.PDM && typeof PDM.customisePresetStripes === 'function') {
      PDM.customisePresetStripes(presetSlug);
    }
    btn.dataset.mode = 'custom';
      // Recently Viewed: entering custom session
    try {
      var st = (window.PDM && PDM.__stripesState) ? Number(PDM.__stripesState.style || 3) : 3;
      var customSlug = (st === 2) ? 'custom-2-stripes' : 'custom-3-stripes';
      if (window.PDM && PDM.recent && PDM.recent.addSlug) PDM.recent.addSlug(customSlug);
    } catch(e) {}


    // Swap to "Reset design" image
    if (img && typeof PDM_RESET_BTN_SRC !== 'undefined' && PDM_RESET_BTN_SRC) {
      img.src = PDM_RESET_BTN_SRC;
      img.alt = 'Reset design';
    } else {
      // Fallback text if image missing
      btn.textContent = 'Reset design';
    }

    // 🔁 After switching to custom, check if this stripes combo is saved
    if (window.PDM && PDM.__stripesState && typeof PDM.findStripeVariant === 'function') {
      var st = PDM.__stripesState;
      var toSlug = function (v) {
        return (v && v.slug) ? v.slug : String(v || '');
      };

      var res = PDM.findStripeVariant(
        Number(st.style || 3),
        toSlug(st.A),
        toSlug(st.B),
        toSlug(st.C)
      ) || { exists: false };

      syncModalHeart(!!res.exists);
    }

    } else {

    // --- NEW: restore preset badge when leaving custom stripes ---
    (function(){
      var $badge = document.querySelector('#pdm-design-modal .pdm-modal__badge');
      if (!$badge) return;

      var prev = String(btn.dataset.prevBadgeText || '').trim().toLowerCase();
      if (prev) {
        $badge.textContent = prev.toUpperCase();
        $badge.setAttribute('data-badge', prev);
        $badge.style.display = '';
      } else {
        // no previous badge (or it was hidden)
        $badge.removeAttribute('data-badge');
        $badge.style.display = (btn.dataset.prevBadgeDisplay === 'none') ? 'none' : 'none';
      }

      // clean up
      delete btn.dataset.prevBadgeText;
      delete btn.dataset.prevBadgeDisplay;
    })();

    // Go back to PRESET view, keeping the same view where possible
    if (window.PDM && typeof PDM.resetPresetStripes === 'function') {
      PDM.resetPresetStripes(presetSlug, currentView);
    }
    btn.dataset.mode = 'preset';
      // Recently Viewed: restoring preset
    try {
      if (presetSlug && window.PDM && PDM.recent && PDM.recent.addSlug) {
        PDM.recent.addSlug(String(presetSlug).toLowerCase());
      }
    } catch(e) {}


    // Swap back to "Customise design" image
    if (img && typeof PDM_CUSTOMISE_BTN_SRC !== 'undefined' && PDM_CUSTOMISE_BTN_SRC) {
      img.src = PDM_CUSTOMISE_BTN_SRC;
      img.alt = 'Customise design';
    } else {
      // Fallback text if image missing
      btn.textContent = 'Customise design';
    }

    // 🔁 For presets, saving is slug-based
    if (window.PDM && typeof PDM.isSaved === 'function') {
      var isSavedPreset = !!PDM.isSaved(String(presetSlug).toLowerCase());
      syncModalHeart(isSavedPreset);
    }
  }
});






      // Toggle front/top image
  document.addEventListener('click', function(e){
    var btn = e.target.closest('.pdm-modal__toggle'); 
    if (!btn) return;

    function swapView() {
            var state = btn.dataset.state || 'front';
      var front = btn.dataset.front;
      var top   = btn.dataset.top;
      var $img  = document.querySelector('#pdm-design-modal .pdm-modal__img');

      // If modal slideshow is enabled, "Change view" must always jump to slide 1 or 2
      // regardless of current slide (gallery slides included).
      try {
        if (
          window.PDM &&
          PDM.modalSlideshow &&
          typeof PDM.modalSlideshow.isEnabled === 'function' &&
          PDM.modalSlideshow.isEnabled() &&
          typeof PDM.modalSlideshow.selectPrimaryOrAlternate === 'function'
        ) {
                    // Toggle between slide 0 and 1 based on the current selected slide,
          // not based on btn.dataset.state (which can be 'top' for stripes).
          var curIdx = (typeof PDM.modalSlideshow.getSelectedIndex === 'function')
            ? PDM.modalSlideshow.getSelectedIndex()
            : 0;

          var targetIndex = (curIdx === 0) ? 1 : 0;
          PDM.modalSlideshow.selectPrimaryOrAlternate(targetIndex);


          // Keep the button's state in sync even while slideshow drives the media
          btn.dataset.state = (state === 'front') ? 'top' : 'front';

          if (window.PDM && PDM.updateOverlays) {
            PDM.updateOverlays();
          }
          return;
        }
      } catch (e) {}

      // Default (static) behaviour
      if ($img) {
        $img.src = (state === 'front') ? top : front;
        $img.alt = ($img.alt || '').replace(
          /front view|top view/i,
          (state === 'front') ? 'top view' : 'front view'
        );
      }

      btn.dataset.state = (state === 'front') ? 'top' : 'front';

      if (window.PDM && PDM.updateOverlays) {
        PDM.updateOverlays();
      }
    }

    if (window.PDM && typeof PDM.crossfadeMedia === 'function') {
  // Locally override just for view toggle
  var modal = document.querySelector('#pdm-design-modal .pdm-modal');
  if (!modal) { swapView(); return; }

  var DURATION = 130;
  modal.classList.add('pdm-fade-media');

  setTimeout(function () {
    swapView();
    modal.classList.remove('pdm-fade-media');
  }, DURATION);
} else {
  swapView();
}

  });



  // Qty +/- in modal
  document.addEventListener('click', function(e){
    var qBtn = e.target.closest('.js-change-quantity'); if (!qBtn) return;
    var input = document.querySelector('#pdm-design-modal #quantity'); if (!input) return;
    var val = parseInt(input.value || '1', 10);
    var fn = qBtn.getAttribute('data-func');
    if (fn === 'minus') val = Math.max(1, val - 1);
    if (fn === 'plus')  val = val + 1;
    input.value = val;
  });

     // Protection level dropdown → persistent state + UI update
  document.addEventListener('change', function(e){
    var sel = e.target.closest('#pdm-protection-select');
    if (!sel) return;

    var level = sel.value || 'elite';
    activeGuardLevel = level;

    if (window.PDM && typeof PDM.updateProtectionUI === 'function') {
      PDM.setGuardContext(level);
    }

        // Modal slideshow: rebuild slides when protection level changes.
    // If user was on slide 3+ (gallery), bounce back to slide 1 (index 0).
    // (No behavioural change unless PDM.enableModalSlideshow === true)
    try {
      if (
        window.PDM &&
        PDM.modalSlideshow &&
        typeof PDM.modalSlideshow.isEnabled === 'function' &&
        PDM.modalSlideshow.isEnabled() &&
        typeof PDM.modalSlideshow.rebuild === 'function'
      ) {
        var shouldBounce = (typeof PDM.modalSlideshow.shouldBounceToPrimaryOnRebuild === 'function')
          ? PDM.modalSlideshow.shouldBounceToPrimaryOnRebuild()
          : false;

        if (shouldBounce && typeof PDM.modalSlideshow.setSelectedIndex === 'function') {
          PDM.modalSlideshow.setSelectedIndex(0);
        }

        PDM.modalSlideshow.rebuild({
          protectionLevel: level,
          bounceToPrimary: shouldBounce
        });
      }
    } catch (e) {}


        // If desktop share box is visible, keep its URL in sync with the new level
    if (typeof __pdmRefreshShareFieldIfVisible === 'function') {
      __pdmRefreshShareFieldIfVisible();
    }


    if (window.PDM && typeof PDM.updateProtectionPrice === 'function') {
      PDM.updateProtectionPrice(level);
    }

    if (window.PDM && typeof PDM.updateVariantSelect === 'function') {
      PDM.updateVariantSelect(level);
    }

    if (window.PDM && typeof PDM.updateJuniorAgeUI === 'function') {
      PDM.updateJuniorAgeUI(level);
    }
  });




  /* ===========================================================
   Add-to-cart injection: junior gate + Colours property
   =========================================================== */
document.addEventListener('click', function(e){
  var btn = e.target.closest('#pdm-modal-add-to-cart');
  if (!btn) return;

  var form = btn.closest('form');
  if (!form) return;

  // Scope everything to the *open* modal (Fancybox clone-safe)
  var modalRoot = btn.closest('#pdm-design-modal') || document;

  // --- 1) Work out the current protection level for THIS modal/form ---
  // Prefer the select inside this form/modal, then fall back to pdmGetCurrentLevel
  var sel =
    form.querySelector('#pdm-protection-select') ||
    modalRoot.querySelector('#pdm-protection-select');

  var currentLevel = sel && sel.value
    ? String(sel.value).toLowerCase()
    : pdmGetCurrentLevel(modalRoot);

  // --- 2) Junior gate – ONLY if age UI is actually visible ---
  var ageHost = form.querySelector('#pdm-age-field');
  var ageSel  = form.querySelector('#pdm-age-select');

  // Visible = not display:none and not in a collapsed parent
  var ageHostVisible = false;
  if (ageHost) {
    var cs = window.getComputedStyle(ageHost);
    ageHostVisible = cs.display !== 'none' && cs.visibility !== 'hidden' && ageHost.offsetParent !== null;
  }

  if (currentLevel === 'junior' && ageHostVisible) {
    var isMissingAge = !ageSel || !ageSel.value;

    if (isMissingAge) {
      // Hard-block click – no submit, no other handlers
      e.preventDefault();
      if (typeof e.stopImmediatePropagation === 'function') {
        e.stopImmediatePropagation();
      }
      e.returnValue = false;

      if (ageSel) {
        ageSel.focus({ preventScroll: false });
        try { ageSel.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch(_){}
        ageSel.style.borderColor = '#ff3b30';
        ageSel.style.boxShadow   = '0 0 0 2px rgba(255,59,48,.15)';
      }

      if (window.PDM && typeof PDM.toast === 'function') {
        PDM.toast("Please select your child's age range before adding to cart", 2700);
      } else {
        alert("Please select your child's age range before adding to cart", 2700);
      }
      return false;
    }

    // Age is valid → inject/update line item property
    var propName = 'properties[Child age range]';
    if (ageSel) {
      var ageInput = form.querySelector('input[name="' + propName.replace(/"/g,'\\"') + '"]');
      if (!ageInput) {
        ageInput = document.createElement('input');
        ageInput.type = 'hidden';
        ageInput.name = propName;
        form.appendChild(ageInput);
      }
      ageInput.value = ageSel.value || '';
    }
  }

  // --- 3) Wishlist + Colours property (unchanged behaviour, just modal-scoped) ---

  // Current design slug is already on the wishlist button
  var wBtn = modalRoot.querySelector('.pdm-wishlist-btn');
  var slug = (wBtn && wBtn.dataset.slug) ? String(wBtn.dataset.slug) : '';

  var summary = (window.PDM && typeof PDM.getStripeSummary === 'function')
    ? PDM.getStripeSummary(slug)
    : '';

  // Create or update the hidden Colours property
  var name = 'properties[Colours]';
  var existing = form.querySelector('input[name="' + name.replace(/"/g,'\\"') + '"]');
  if (!existing){
    existing = document.createElement('input');
    existing.type = 'hidden';
    existing.name = name;
    form.appendChild(existing);
  }
  existing.value = summary || '';

}, false);




// ===========================================================
// PDM Guide trigger – opens guide inside existing Fancybox
// or as a standalone fallback.
// ===========================================================
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-pdm-guide-trigger]');
  if (!btn) return;

  e.preventDefault();

  var mode = btn.getAttribute('data-pdm-guide-mode') || 'standalone';

  window.PDMGuide = window.PDMGuide || {};
  window.PDMGuide.mode = mode;

  // 1) Preferred: add as a slide to the existing design modal instance
  if (window.Fancybox && typeof Fancybox.getInstance === 'function') {
    var fb = Fancybox.getInstance();
    if (fb) {
      fb.addSlide({ src: '#pdm-guide', type: 'inline' });
      fb.jumpTo(fb.slides.length - 1);
      return;
    }
  }

  // 2) Fallback: standalone
  if (window.Fancybox && typeof Fancybox.show === 'function') {
    Fancybox.show([{ src: '#pdm-guide', type: 'inline' }], {
      dragToClose: false,
      touch: false
    });
  } else if (window.jQuery && jQuery.fancybox) {
    jQuery.fancybox.open({
      src: '#pdm-guide',
      type: 'inline',
      touch: false
    });
  } else {
    var el = document.getElementById('pdm-guide');
    if (el) el.style.display = 'block';
  }
}, false);





  // Wishlist toggle (delegated)
document.addEventListener('click', function(e){
  var wBtn = e.target.closest('.pdm-wishlist-btn'); 
  if (!wBtn) return;

  // local esc (doesn't rely on first script's scope)
  function escSel(s){
    try { return (window.CSS && CSS.escape) ? CSS.escape(s) : String(s).replace(/"/g, '\\"'); }
    catch(err){ return String(s).replace(/"/g, '\\"'); }
  }

    const slug = (wBtn.dataset.slug || '').toLowerCase();
  const modal = document.querySelector('#pdm-design-modal .pdm-modal');
  const isStripes = modal && modal.classList.contains('is-stripes-custom');

  function syncStripesSaveBtn(saved){
  var sBtn = document.querySelector('#pdm-design-modal .js-stripes-save');
  if (!sBtn) return;

  sBtn.classList.toggle('is-active', !!saved);
  sBtn.setAttribute('aria-label', saved ? 'Unsave design' : 'Save design');
  sBtn.setAttribute('title', saved ? 'Unsave design' : 'Save design');

  var ii = sBtn.querySelector('i');
  if (ii){
    ii.classList.add('fa-heart'); // ensure glyph class
    ii.classList.remove(saved ? 'fa-regular' : 'fa-solid');
    ii.classList.add(saved ? 'fa-solid' : 'fa-regular');
  }
}


  // ==== Custom-Stripes variant SAVE (title = colour way) ====
  // ==== Custom-Stripes variant SAVE (title & overlay thumbnail) ====
if (isStripes) {
  const st = (window.PDM && PDM.__stripesState) || {};
  const style = Number(st.style || 3);

  const toSlug = v => (v && v.slug) ? v.slug : String(v || '');
  const A = toSlug(st.A) || 'blue';
  const B = toSlug(st.B) || 'white';
  const C = toSlug(st.C) || 'black';

  // A compact, deterministic ID for this variant (2-stripe ignores middle)
const saved_id = (window.PDM && PDM.stripeKey) ? PDM.stripeKey(style, A, B, C)
                                               : [style, A, B, C].join('|');

  if (window.PDM && PDM.getDesignBySlug) {
    const d = PDM.getDesignBySlug(slug);
    if (d) {
      // Toggle behaviour: if it already exists, remove; else save
      var existing = (PDM.findStripeVariant) ? PDM.findStripeVariant(style, A, B, C)
                                       : { exists:false, saved_id:saved_id, idx:-1 };
    if (existing.exists) {
      // Remove whichever saved_id matched (normalised for style 2)
      PDM.removeVariant(existing.saved_id);
      if (window.PDM && PDM.setCardHeartState) PDM.setCardHeartState(wBtn, false);
      wBtn.classList.remove('is-active');
      wBtn.setAttribute('aria-pressed','false');
      syncStripesSaveBtn(false);
      PDM.toast('Removed from My Saved');

      // Mirror to any card-hearts representing this exact saved variant (e.g. Recently Viewed)
      try {
        var sid2 = String(existing.saved_id || '');
        var slug2 = String(slug || '').toLowerCase();

        document.querySelectorAll('.pdm-card-heart[data-saved-id="' + sid2.replace(/"/g,'\\"') + '"]')
          .forEach(function(h){
            // flip visual state (modal file doesn't have setCardHeartState in scope)
            h.classList.remove('is-active');
            h.setAttribute('aria-pressed', 'false');
            h.setAttribute('aria-label', 'Save design');

            var ii = h.querySelector('i');
            if (ii) {
              ii.classList.remove('fa-solid');
              ii.classList.add('fa-regular');
            } else {
              // fallback in case markup differs
              h.innerHTML = '<i class="fa-regular fa-heart" aria-hidden="true"></i>';
            }

            // allow re-save of the exact same variant next click (RV behaviour)
            h.dataset.variantKey = sid2;
            delete h.dataset.savedId;
            h.dataset.slug = slug2;

          });
      } catch(e) {}

      // If user is currently viewing My Saved (any mode), refresh
      if (PDM.getSelectedKey && PDM.getSelectedKey()==='my-saved' && PDM.forceRender) {
        PDM.forceRender();
      }
      return;
    }



      // Build a lean saved object (thumbnail best-effort)
      const defaultTitle = (style === 2) ? 'Custom 2 Stripes' : 'Custom 3 Stripes';
      const savedObj = Object.assign({}, d, {
        slug: slug,
        title_override: defaultTitle,              // keep your requirement
        __savedVariant: { isCustomStripes:true, style, A, B, C },
        saved_id: saved_id
      });

            // NOTE: Canvas/dataURL thumbnail generation removed (storage overload).
            // Saved variants render thumbnails as base-top + overlay images at runtime.
      try {
        PDM.addVariant(savedObj);
      } catch (err) { /* noop */ }

      // Recently Viewed: add this saved variant immediately (same-tab, so no storage event)
      try {
        if (window.PDM && PDM.recent && typeof PDM.recent.addVariant === 'function') {
          PDM.recent.addVariant(saved_id);
        }
        if (window.PDM && typeof PDM.renderRecentlyViewed === 'function') {
          PDM.renderRecentlyViewed();
        }
      } catch (e) { /* noop */ }

      // reflect modal heart
      if (window.PDM && PDM.setCardHeartState) PDM.setCardHeartState(wBtn, true);

      wBtn.classList.add('is-active');
      wBtn.setAttribute('aria-pressed','true');
      syncStripesSaveBtn(true);
      PDM.toast('Added to My Saved');

      // If user is on My Saved (category OR colour pill), refresh the carousel
      if (PDM.getSelectedKey && PDM.getSelectedKey()==='my-saved' &&
          PDM.forceRender) {
        PDM.forceRender();
      }



      return;
    }
  }

  // Safety: if something went wrong above, don’t fall back to slug storage for stripes
  return;
}




  if (!slug || !window.PDM || !PDM.toggleSave) return;


  var nowSaved = PDM.toggleSave(slug);
  PDM.toast(nowSaved ? 'Added to My Saved' : 'Removed from My Saved');
    // If user is currently viewing My Saved (any mode), refresh after add/remove
    if (PDM.getSelectedKey && PDM.getSelectedKey()==='my-saved' && PDM.forceRender) {
      PDM.forceRender();
    }


  // 1) Update the modal heart (existing helper)
  setWishlistButtonState(wBtn, nowSaved);
  wBtn.setAttribute('aria-pressed', nowSaved ? 'true' : 'false');

  // Also enforce robust FA swap in case the kit uses SVG
  if (window.PDM && PDM.setCardHeartState) { 
    PDM.setCardHeartState(wBtn, nowSaved); 
  }

  // 2) Mirror ALL card hearts for this slug (instant visual flip)
  document.querySelectorAll('.pdm-card-heart[data-slug="' + escSel(slug) + '"]').forEach(function(h){
    if (window.PDM && PDM.setCardHeartState) {
      PDM.setCardHeartState(h, nowSaved);
    } else {
      // fallback: minimal class toggle if helper missing
      h.classList.toggle('is-active', nowSaved);
      h.setAttribute('aria-pressed', nowSaved ? 'true' : 'false');
      var i = h.querySelector('i.fa-heart');
      if (i){ i.classList.toggle('fa-regular', !nowSaved); i.classList.toggle('fa-solid', nowSaved); }
    }
  });

  // 3) If currently on "My Saved", re-render that carousel
  if (PDM.getSelectedKey && PDM.getSelectedKey()==='my-saved' && PDM.forceRender){
    PDM.forceRender();
  }

});

// Live-sync modal heart if storage changes elsewhere (slugs + custom stripes variants)
window.addEventListener('storage', function(ev){
  var key  = ev.key;
  var wBtn = document.querySelector('#pdm-design-modal .pdm-wishlist-btn');
  if (!wBtn || !window.PDM) return;

  // ----- Case 1: simple slug saves (non-stripes) -----
  if (key === 'pdm_saved_slugs_v1') {
    if (!PDM.isSaved) return;
    var slug = (wBtn.dataset.slug || '').toLowerCase();
    if (!slug) return;

    var isNowSaved = !!PDM.isSaved(slug);
    if (typeof setWishlistButtonState === 'function') setWishlistButtonState(wBtn, isNowSaved);
    if (PDM.setCardHeartState) PDM.setCardHeartState(wBtn, isNowSaved);
    return;
  }

  // ----- Case 2: custom stripes variants (variant list or order changed) -----
  if (key === 'pdm_saved_variants_v1' || key === 'pdm_saved_order_v1') {
    var modal = document.querySelector('#pdm-design-modal .pdm-modal');
    if (!modal || !modal.classList.contains('is-stripes-custom')) return;
    if (!PDM.findStripeVariant) return;

    var st = PDM.__stripesState || {};
    var toSlug = function(v){
      return (v && v.slug) ? v.slug : String(v || '');
    };

    var res = PDM.findStripeVariant(
      Number(st.style || 3),
      toSlug(st.A),
      toSlug(st.B),
      toSlug(st.C)
    );
    var savedNow = !!(res && res.exists);

    if (typeof setWishlistButtonState === 'function') setWishlistButtonState(wBtn, savedNow);
    if (PDM.setCardHeartState) PDM.setCardHeartState(wBtn, savedNow);
  }
});



document.addEventListener('DOMContentLoaded', function () {
  if (!window.PDMGuide) return;

  window.PDMGuide.onSelectProtection = function (guardKey, mg) {
    if (window.PDM && typeof PDM.setGuardContext === 'function') {
      PDM.setGuardContext(guardKey, mg);
    }
  };
});




})();